var Ln = Object.defineProperty, In = Object.defineProperties;
var Un = Object.getOwnPropertyDescriptors;
var ze = Object.getOwnPropertySymbols;
var Et = Object.prototype.hasOwnProperty, $t = Object.prototype.propertyIsEnumerable;
var Se = (e, t) => (t = Symbol[e]) ? t : Symbol.for("Symbol." + e), Mn = (e) => {
  throw TypeError(e);
};
var vt = (e, t, n) => t in e ? Ln(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, T = (e, t) => {
  for (var n in t || (t = {}))
    Et.call(t, n) && vt(e, n, t[n]);
  if (ze)
    for (var n of ze(t))
      $t.call(t, n) && vt(e, n, t[n]);
  return e;
}, X = (e, t) => In(e, Un(t));
var ke = (e, t) => {
  var n = {};
  for (var s in e)
    Et.call(e, s) && t.indexOf(s) < 0 && (n[s] = e[s]);
  if (e != null && ze)
    for (var s of ze(e))
      t.indexOf(s) < 0 && $t.call(e, s) && (n[s] = e[s]);
  return n;
};
var ie = (e, t, n) => new Promise((s, r) => {
  var i = (c) => {
    try {
      a(n.next(c));
    } catch (d) {
      r(d);
    }
  }, o = (c) => {
    try {
      a(n.throw(c));
    } catch (d) {
      r(d);
    }
  }, a = (c) => c.done ? s(c.value) : Promise.resolve(c.value).then(i, o);
  a((n = n.apply(e, t)).next());
}), pe = function(e, t) {
  this[0] = e, this[1] = t;
}, ot = (e, t, n) => {
  var s = (o, a, c, d) => {
    try {
      var u = n[o](a), x = (a = u.value) instanceof pe, S = u.done;
      Promise.resolve(x ? a[0] : a).then((R) => x ? s(o === "return" ? o : "next", a[1] ? { done: R.done, value: R.value } : R, c, d) : c({ value: R, done: S })).catch((R) => s("throw", R, c, d));
    } catch (R) {
      d(R);
    }
  }, r = (o) => i[o] = (a) => new Promise((c, d) => s(o, a, c, d)), i = {};
  return n = n.apply(e, t), i[Se("asyncIterator")] = () => i, r("next"), r("throw"), r("return"), i;
}, at = (e) => {
  var t = e[Se("asyncIterator")], n = !1, s, r = {};
  return t == null ? (t = e[Se("iterator")](), s = (i) => r[i] = (o) => t[i](o)) : (t = t.call(e), s = (i) => r[i] = (o) => {
    if (n) {
      if (n = !1, i === "throw") throw o;
      return o;
    }
    return n = !0, {
      done: !1,
      value: new pe(new Promise((a) => {
        var c = t[i](o);
        c instanceof Object || Mn("Object expected"), a(c);
      }), 1)
    };
  }), r[Se("iterator")] = () => r, s("next"), "throw" in t ? s("throw") : r.throw = (i) => {
    throw i;
  }, "return" in t && s("return"), r;
}, Nt = (e, t, n) => (t = e[Se("asyncIterator")]) ? t.call(e) : (e = e[Se("iterator")](), t = {}, n = (s, r) => (r = e[s]) && (t[s] = (i) => new Promise((o, a, c) => (i = r.call(e, i), c = i.done, Promise.resolve(i.value).then((d) => o({ value: d, done: c }), a)))), n("next"), n("return"), t);
import { jsxs as N, Fragment as te, jsx as f } from "react/jsx-runtime";
import * as de from "react";
import sn, { useState as G, useRef as ee, useEffect as ae, useCallback as ct } from "react";
function zn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ce = {}, Ot;
function Bn() {
  if (Ot) return Ce;
  Ot = 1;
  var e = sn;
  function t(w) {
    return w && typeof w == "object" && "default" in w ? w : { default: w };
  }
  var n = /* @__PURE__ */ t(e);
  function s(w, b) {
    for (var y = 0; y < b.length; y++) {
      var p = b[y];
      p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(w, p.key, p);
    }
  }
  function r(w, b, y) {
    return b && s(w.prototype, b), w;
  }
  var i = typeof process != "undefined" && process.env && process.env.NODE_ENV === "production", o = function(w) {
    return Object.prototype.toString.call(w) === "[object String]";
  }, a = /* @__PURE__ */ (function() {
    function w(y) {
      var p = y === void 0 ? {} : y, m = p.name, j = m === void 0 ? "stylesheet" : m, C = p.optimizeForSpeed, E = C === void 0 ? i : C;
      c(o(j), "`name` must be a string"), this._name = j, this._deletedRulePlaceholder = "#" + j + "-deleted-rule____{}", c(typeof E == "boolean", "`optimizeForSpeed` must be a boolean"), this._optimizeForSpeed = E, this._serverSheet = void 0, this._tags = [], this._injected = !1, this._rulesCount = 0;
      var V = typeof window != "undefined" && document.querySelector('meta[property="csp-nonce"]');
      this._nonce = V ? V.getAttribute("content") : null;
    }
    var b = w.prototype;
    return b.setOptimizeForSpeed = function(p) {
      c(typeof p == "boolean", "`setOptimizeForSpeed` accepts a boolean"), c(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted"), this.flush(), this._optimizeForSpeed = p, this.inject();
    }, b.isOptimizeForSpeed = function() {
      return this._optimizeForSpeed;
    }, b.inject = function() {
      var p = this;
      if (c(!this._injected, "sheet already injected"), this._injected = !0, typeof window != "undefined" && this._optimizeForSpeed) {
        this._tags[0] = this.makeStyleTag(this._name), this._optimizeForSpeed = "insertRule" in this.getSheet(), this._optimizeForSpeed || (i || console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode."), this.flush(), this._injected = !0);
        return;
      }
      this._serverSheet = {
        cssRules: [],
        insertRule: function(m, j) {
          return typeof j == "number" ? p._serverSheet.cssRules[j] = {
            cssText: m
          } : p._serverSheet.cssRules.push({
            cssText: m
          }), j;
        },
        deleteRule: function(m) {
          p._serverSheet.cssRules[m] = null;
        }
      };
    }, b.getSheetForTag = function(p) {
      if (p.sheet)
        return p.sheet;
      for (var m = 0; m < document.styleSheets.length; m++)
        if (document.styleSheets[m].ownerNode === p)
          return document.styleSheets[m];
    }, b.getSheet = function() {
      return this.getSheetForTag(this._tags[this._tags.length - 1]);
    }, b.insertRule = function(p, m) {
      if (c(o(p), "`insertRule` accepts only strings"), typeof window == "undefined")
        return typeof m != "number" && (m = this._serverSheet.cssRules.length), this._serverSheet.insertRule(p, m), this._rulesCount++;
      if (this._optimizeForSpeed) {
        var j = this.getSheet();
        typeof m != "number" && (m = j.cssRules.length);
        try {
          j.insertRule(p, m);
        } catch (E) {
          return i || console.warn(`StyleSheet: illegal rule: 

` + p + `

See https://stackoverflow.com/q/20007992 for more info`), -1;
        }
      } else {
        var C = this._tags[m];
        this._tags.push(this.makeStyleTag(this._name, p, C));
      }
      return this._rulesCount++;
    }, b.replaceRule = function(p, m) {
      if (this._optimizeForSpeed || typeof window == "undefined") {
        var j = typeof window != "undefined" ? this.getSheet() : this._serverSheet;
        if (m.trim() || (m = this._deletedRulePlaceholder), !j.cssRules[p])
          return p;
        j.deleteRule(p);
        try {
          j.insertRule(m, p);
        } catch (E) {
          i || console.warn(`StyleSheet: illegal rule: 

` + m + `

See https://stackoverflow.com/q/20007992 for more info`), j.insertRule(this._deletedRulePlaceholder, p);
        }
      } else {
        var C = this._tags[p];
        c(C, "old rule at index `" + p + "` not found"), C.textContent = m;
      }
      return p;
    }, b.deleteRule = function(p) {
      if (typeof window == "undefined") {
        this._serverSheet.deleteRule(p);
        return;
      }
      if (this._optimizeForSpeed)
        this.replaceRule(p, "");
      else {
        var m = this._tags[p];
        c(m, "rule at index `" + p + "` not found"), m.parentNode.removeChild(m), this._tags[p] = null;
      }
    }, b.flush = function() {
      this._injected = !1, this._rulesCount = 0, typeof window != "undefined" ? (this._tags.forEach(function(p) {
        return p && p.parentNode.removeChild(p);
      }), this._tags = []) : this._serverSheet.cssRules = [];
    }, b.cssRules = function() {
      var p = this;
      return typeof window == "undefined" ? this._serverSheet.cssRules : this._tags.reduce(function(m, j) {
        return j ? m = m.concat(Array.prototype.map.call(p.getSheetForTag(j).cssRules, function(C) {
          return C.cssText === p._deletedRulePlaceholder ? null : C;
        })) : m.push(null), m;
      }, []);
    }, b.makeStyleTag = function(p, m, j) {
      m && c(o(m), "makeStyleTag accepts only strings as second parameter");
      var C = document.createElement("style");
      this._nonce && C.setAttribute("nonce", this._nonce), C.type = "text/css", C.setAttribute("data-" + p, ""), m && C.appendChild(document.createTextNode(m));
      var E = document.head || document.getElementsByTagName("head")[0];
      return j ? E.insertBefore(C, j) : E.appendChild(C), C;
    }, r(w, [
      {
        key: "length",
        get: function() {
          return this._rulesCount;
        }
      }
    ]), w;
  })();
  function c(w, b) {
    if (!w)
      throw new Error("StyleSheet: " + b + ".");
  }
  function d(w) {
    for (var b = 5381, y = w.length; y; )
      b = b * 33 ^ w.charCodeAt(--y);
    return b >>> 0;
  }
  var u = d, x = function(w) {
    return w.replace(/\/style/gi, "\\/style");
  }, S = {};
  function R(w, b) {
    if (!b)
      return "jsx-" + w;
    var y = String(b), p = w + y;
    return S[p] || (S[p] = "jsx-" + u(w + "-" + y)), S[p];
  }
  function h(w, b) {
    var y = /__jsx-style-dynamic-selector/g;
    typeof window == "undefined" && (b = x(b));
    var p = w + b;
    return S[p] || (S[p] = b.replace(y, w)), S[p];
  }
  function _(w, b) {
    return b === void 0 && (b = {}), w.map(function(y) {
      var p = y[0], m = y[1];
      return /* @__PURE__ */ n.default.createElement("style", {
        id: "__" + p,
        // Avoid warnings upon render with a key
        key: "__" + p,
        nonce: b.nonce ? b.nonce : void 0,
        dangerouslySetInnerHTML: {
          __html: m
        }
      });
    });
  }
  var g = /* @__PURE__ */ (function() {
    function w(y) {
      var p = y === void 0 ? {} : y, m = p.styleSheet, j = m === void 0 ? null : m, C = p.optimizeForSpeed, E = C === void 0 ? !1 : C;
      this._sheet = j || new a({
        name: "styled-jsx",
        optimizeForSpeed: E
      }), this._sheet.inject(), j && typeof E == "boolean" && (this._sheet.setOptimizeForSpeed(E), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }
    var b = w.prototype;
    return b.add = function(p) {
      var m = this;
      this._optimizeForSpeed === void 0 && (this._optimizeForSpeed = Array.isArray(p.children), this._sheet.setOptimizeForSpeed(this._optimizeForSpeed), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), typeof window != "undefined" && !this._fromServer && (this._fromServer = this.selectFromServer(), this._instancesCounts = Object.keys(this._fromServer).reduce(function(D, ye) {
        return D[ye] = 0, D;
      }, {}));
      var j = this.getIdAndRules(p), C = j.styleId, E = j.rules;
      if (C in this._instancesCounts) {
        this._instancesCounts[C] += 1;
        return;
      }
      var V = E.map(function(D) {
        return m._sheet.insertRule(D);
      }).filter(function(D) {
        return D !== -1;
      });
      this._indices[C] = V, this._instancesCounts[C] = 1;
    }, b.remove = function(p) {
      var m = this, j = this.getIdAndRules(p).styleId;
      if (O(j in this._instancesCounts, "styleId: `" + j + "` not found"), this._instancesCounts[j] -= 1, this._instancesCounts[j] < 1) {
        var C = this._fromServer && this._fromServer[j];
        C ? (C.parentNode.removeChild(C), delete this._fromServer[j]) : (this._indices[j].forEach(function(E) {
          return m._sheet.deleteRule(E);
        }), delete this._indices[j]), delete this._instancesCounts[j];
      }
    }, b.update = function(p, m) {
      this.add(m), this.remove(p);
    }, b.flush = function() {
      this._sheet.flush(), this._sheet.inject(), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }, b.cssRules = function() {
      var p = this, m = this._fromServer ? Object.keys(this._fromServer).map(function(C) {
        return [
          C,
          p._fromServer[C]
        ];
      }) : [], j = this._sheet.cssRules();
      return m.concat(Object.keys(this._indices).map(function(C) {
        return [
          C,
          p._indices[C].map(function(E) {
            return j[E].cssText;
          }).join(p._optimizeForSpeed ? "" : `
`)
        ];
      }).filter(function(C) {
        return !!C[1];
      }));
    }, b.styles = function(p) {
      return _(this.cssRules(), p);
    }, b.getIdAndRules = function(p) {
      var m = p.children, j = p.dynamic, C = p.id;
      if (j) {
        var E = R(C, j);
        return {
          styleId: E,
          rules: Array.isArray(m) ? m.map(function(V) {
            return h(E, V);
          }) : [
            h(E, m)
          ]
        };
      }
      return {
        styleId: R(C),
        rules: Array.isArray(m) ? m : [
          m
        ]
      };
    }, b.selectFromServer = function() {
      var p = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
      return p.reduce(function(m, j) {
        var C = j.id.slice(2);
        return m[C] = j, m;
      }, {});
    }, w;
  })();
  function O(w, b) {
    if (!w)
      throw new Error("StyleSheetRegistry: " + b + ".");
  }
  var $ = /* @__PURE__ */ e.createContext(null);
  $.displayName = "StyleSheetContext";
  function k() {
    return new g();
  }
  function A(w) {
    var b = w.registry, y = w.children, p = e.useContext($), m = e.useState(function() {
      return p || b || k();
    }), j = m[0];
    return /* @__PURE__ */ n.default.createElement($.Provider, {
      value: j
    }, y);
  }
  function I() {
    return e.useContext($);
  }
  var q = n.default.useInsertionEffect || n.default.useLayoutEffect, F = typeof window != "undefined" ? k() : void 0;
  function L(w) {
    var b = F || I();
    return b ? typeof window == "undefined" ? (b.add(w), null) : (q(function() {
      return b.add(w), function() {
        b.remove(w);
      };
    }, [
      w.id,
      String(w.dynamic)
    ]), null) : null;
  }
  return L.dynamic = function(w) {
    return w.map(function(b) {
      var y = b[0], p = b[1];
      return R(y, p);
    }).join(" ");
  }, Ce.StyleRegistry = A, Ce.createStyleRegistry = k, Ce.style = L, Ce.useStyleRegistry = I, Ce;
}
var lt, At;
function Dn() {
  return At || (At = 1, lt = Bn().style), lt;
}
var Hn = Dn();
const Q = /* @__PURE__ */ zn(Hn);
function rn(e) {
  var t, n, s = "";
  if (typeof e == "string" || typeof e == "number") s += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = rn(e[t])) && (s && (s += " "), s += n);
  } else for (n in e) e[n] && (s && (s += " "), s += n);
  return s;
}
function qn() {
  for (var e, t, n = 0, s = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = rn(e)) && (s && (s += " "), s += t);
  return s;
}
const ce = qn, Vn = (e) => /* @__PURE__ */ de.createElement("svg", T({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 41 20", fill: "none" }, e), /* @__PURE__ */ de.createElement("path", { d: "M10.1962 0.00761822C11.1031 0.00761822 12.0002 0.464711 12.7124 1.16994L17.141 6.58432C17.4408 6.31006 17.8357 6.1577 18.2449 6.15987C19.3247 6.18817 20.1879 7.05991 20.1934 8.13082V16.5707C20.1934 18.4024 18.5994 20 16.7428 20H8.20834C6.587 20 5.57941 18.1205 6.62857 16.9919L1.15737 12.6049C-0.0985676 11.3631 -0.547117 9.5293 0.912309 8.08293L8.17661 0.889155C8.69956 0.331937 9.43036 0.0108833 10.1984 0", fill: "#E40046" }), /* @__PURE__ */ de.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.13784 9.46965L5.84415 9.41446H5.8447C5.80771 9.40244 5.80771 9.38878 5.81931 9.35654L6.03847 8.84451C6.05593 8.80295 6.0762 8.80569 6.10495 8.80959C6.11438 8.81086 6.12472 8.81226 6.13618 8.81226L6.47624 8.87456C6.50163 8.88385 6.51819 8.90243 6.50163 8.92757L6.21015 9.44452C6.18421 9.46965 6.17261 9.46965 6.13784 9.46965H6.13784ZM9.7129 9.77383C9.45973 9.68749 9.11955 9.68203 8.92802 9.68203C8.55185 9.67547 8.19939 9.86236 7.99641 10.176V9.80225C7.976 9.70498 7.8872 9.63613 7.78681 9.6405H7.08797C6.9749 9.6394 6.88224 9.72902 6.88058 9.84105V9.84323V11.9198C6.88058 12.2564 6.72228 12.746 6.18174 12.746C5.40843 12.746 5.4669 11.823 5.4669 11.823V9.8017C5.45808 9.70115 5.37038 9.62574 5.26889 9.63121H4.55626C4.45477 9.62356 4.36651 9.69897 4.35934 9.79952C4.35824 9.81263 4.35934 9.82574 4.36045 9.83885L4.36045 9.83886V11.7356C4.36045 12.7023 4.53971 13.3094 5.17346 13.5471C5.42609 13.6356 5.69305 13.6772 5.96056 13.6695C6.33728 13.6761 6.68974 13.4881 6.89216 13.1733V13.5171C6.90981 13.6154 6.99917 13.6848 7.09956 13.6788H7.7984C7.91147 13.6777 8.00303 13.5875 8.00579 13.4755V11.4312C8.00579 11.0919 8.15968 10.6006 8.70463 10.6006C9.47573 10.6006 9.41947 11.5236 9.41947 11.5236V13.5493C9.41947 13.6324 9.44484 13.6668 9.50331 13.6783H10.3676C10.5099 13.6783 10.5259 13.6553 10.5259 13.5444V11.5875C10.5259 10.6208 10.3467 10.0137 9.7129 9.77383ZM10.9493 13.6949H11.7225C11.867 13.6949 11.888 13.6719 11.888 13.561V9.77241C11.888 9.66148 11.867 9.63853 11.7225 9.63853H10.9493C10.8379 9.63853 10.7888 9.66148 10.7888 9.77241V13.561C10.7888 13.6719 10.8374 13.6949 10.9493 13.6949ZM18.7036 13.4941C18.1939 13.6963 17.6472 13.7914 17.0989 13.7733C15.7362 13.7733 15.333 13.217 15.333 12.5203C15.333 11.7471 15.8477 11.1777 16.9311 11.1777H17.7653V11.0574C17.7653 10.7804 17.6742 10.5246 17.106 10.5246C16.7458 10.5296 16.3878 10.5777 16.0391 10.6678C15.9089 10.6979 15.8714 10.6678 15.8482 10.5711L15.7269 10.0449C15.6965 9.93174 15.7269 9.90387 15.8035 9.87436C16.2741 9.71753 16.7679 9.63939 17.2638 9.64376C18.3611 9.64376 18.8642 10.105 18.8642 11.0279V13.2017C18.8824 13.3236 18.8167 13.4422 18.7036 13.4925V13.4941ZM17.1568 11.905C16.8798 11.905 16.4578 11.9558 16.4578 12.4356C16.4578 12.7886 16.7165 12.9088 17.1193 12.9088C17.3328 12.9116 17.5457 12.8788 17.7482 12.8121V11.9055H17.1562L17.1568 11.905ZM14.9529 12.6287C15.0831 12.5778 15.1112 12.5871 15.1509 12.6981L15.3628 13.2609C15.4163 13.3604 15.4234 13.4106 15.307 13.4707C14.8729 13.6828 14.3935 13.7882 13.9097 13.7779C12.7219 13.7779 12.0925 13.0855 12.0925 11.7379C12.0925 10.3904 12.819 9.6614 13.977 9.6614C14.3902 9.65429 14.8001 9.74118 15.1741 9.91495C15.3043 9.97506 15.3092 10.0051 15.2579 10.1248L15.0461 10.704C14.9948 10.815 14.9551 10.8079 14.8133 10.7685C14.5711 10.6876 14.3185 10.6428 14.063 10.6346C13.4645 10.6346 13.2361 11.1445 13.2361 11.7374C13.2361 12.3303 13.4154 12.8013 14.084 12.8013C14.3824 12.7948 14.6776 12.7358 14.9551 12.6259L14.9529 12.6287Z", fill: "#FFFFFF" }), /* @__PURE__ */ de.createElement("path", { d: "M21.1106 8.6C21.1106 8.03995 21.1106 7.75992 21.2202 7.54601C21.3165 7.35785 21.4703 7.20487 21.6595 7.10899C21.8745 7 22.156 7 22.719 7H39.036C39.599 7 39.8805 7 40.0955 7.10899C40.2846 7.20487 40.4384 7.35785 40.5348 7.54601C40.6444 7.75992 40.6444 8.03995 40.6444 8.6V17.5794C40.6444 18.1394 40.6444 18.4194 40.5348 18.6334C40.4384 18.8215 40.2846 18.9745 40.0955 19.0704C39.8805 19.1794 39.599 19.1794 39.036 19.1794H22.719C22.156 19.1794 21.8745 19.1794 21.6595 19.0704C21.4703 18.9745 21.3165 18.8215 21.2202 18.6334C21.1106 18.4194 21.1106 18.1394 21.1106 17.5794V8.6Z", fill: "#3DAE2B" }), /* @__PURE__ */ de.createElement("path", { d: "M38.5821 15.3213L37.9935 14.7369L37.0931 13.8444L37.2102 13.8183C38.0121 13.6518 38.5515 13.149 38.5515 12.1848C38.5515 11.0594 37.603 10.4336 36.6544 10.4315H34.6743C34.6557 10.4326 34.6371 10.4369 34.6196 10.4456C34.6053 10.4543 34.5988 10.4761 34.5988 10.5131V15.4192C34.6053 15.453 34.6152 15.4736 34.6294 15.4802C34.6524 15.4889 34.6754 15.49 34.6983 15.4856H34.7104L35.5331 15.367C35.5462 15.3659 35.5604 15.3615 35.5725 15.355C35.5878 15.3463 35.5932 15.3235 35.5932 15.2886V11.3957H36.6927C37.1675 11.3957 37.5811 11.7309 37.5811 12.176C37.5811 12.6212 37.2507 12.8464 36.7813 12.9607C36.3109 13.0739 36.0845 13.4145 36.0823 13.7737C36.0866 14.0207 36.1818 14.2569 36.3503 14.4387C36.4324 14.5442 36.5221 14.6433 36.6194 14.7369C36.6216 14.739 36.6238 14.7412 36.6271 14.7434L37.9443 16.0744C38.0263 16.1266 38.1226 16.1538 38.22 16.1538C38.4968 16.1549 38.721 15.9351 38.7254 15.6608C38.7276 15.5335 38.6762 15.4105 38.5832 15.3235M27.8924 14.0479C27.8093 13.9957 27.713 13.9674 27.6145 13.9674C27.4778 13.9674 27.3487 14.0229 27.2546 14.1209C27.2262 14.1557 27.1616 14.2156 27.1365 14.2395C26.794 14.5562 26.3422 14.7325 25.8729 14.7325C24.8445 14.7314 24.0108 13.9021 24.0097 12.878C24.013 11.8572 24.8467 11.0311 25.8729 11.0311C26.2142 11.0311 26.6802 11.0921 27.0905 11.4795C27.0949 11.4839 27.0993 11.4871 27.1047 11.4893C27.1266 11.5002 27.1507 11.5024 27.1736 11.4958L28.0532 11.3674C28.1419 11.3544 28.0992 11.2869 28.0992 11.2869C27.9427 11.0039 27.2907 10.0103 25.7853 10.0244C24.1946 10.0397 23.0043 11.2804 22.989 12.8943C22.9912 13.5724 23.2352 14.2275 23.6782 14.7423C24.2253 15.3844 25.0272 15.7555 25.8729 15.7577C26.6649 15.7555 27.4198 15.4334 27.9668 14.8631C27.9974 14.825 28.0237 14.7847 28.0467 14.7423C28.0981 14.6596 28.1254 14.5638 28.1276 14.467C28.1254 14.2983 28.0379 14.1415 27.8957 14.0501M33.3374 10.2421C32.926 10.2421 32.6908 10.5316 32.5092 10.9114L31.3856 13.2894C31.3856 13.2894 31.3747 13.3177 31.3572 13.3177C31.3397 13.3177 31.3266 13.2894 31.3266 13.2894L30.366 11.6634L30.0695 11.1574C30.052 11.1291 30.0345 11.1128 30.017 11.1117C30.0083 11.1106 29.9984 11.1106 29.9897 11.1117L28.6768 11.2956C28.6648 11.2989 28.6528 11.3032 28.6418 11.3097C28.6298 11.3174 28.6232 11.3402 28.6232 11.3761V15.6619C28.6298 15.9296 28.8508 16.144 29.1199 16.144C29.389 16.143 29.61 15.9296 29.6177 15.6619V12.3687L31.0476 14.7434L31.3539 15.2495C31.3594 15.2603 31.3692 15.2669 31.3802 15.268C31.3944 15.268 31.4031 15.2495 31.4031 15.2495L31.6515 14.7434L33.0923 11.8387V15.6423C33.0978 15.675 33.1076 15.6957 33.124 15.7033C33.1426 15.7098 33.1623 15.712 33.182 15.7098H33.1886L34.0189 15.5912C34.0354 15.5901 34.0507 15.5847 34.0649 15.5781C34.0813 15.5683 34.0846 15.5477 34.0868 15.5172V10.9909C34.0791 10.5795 33.7454 10.2486 33.3319 10.2421", fill: "#FFFFFF" })), on = "720px", Wn = "#dddddd", Jn = "#a6a6a6", mt = "#343e49", Xn = "#c0c0c0", Gn = "#8b8b8b", dt = "#e7e7e7", Kn = "#cacaca", jt = "#f0f0f0", Zn = "#767676", Qn = "#4a4a4a", Yn = "#bbbbbb", es = "#e0e0e0", ts = "#e4022d", he = "#ffffff", St = "#333333", ns = "#717171", ut = "#000000", ss = "#FFC107", le = "'Lato', sans-serif", Qe = "12px", Ke = "14px", Ye = "16px", an = "20px", Re = [".container-recommended-products-ui.jsx-3367411885{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;gap:2px;margin-bottom:1px;}", ".container-recommended-products-ui.jsx-3367411885 .price-container.jsx-3367411885{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:4px;}", `.container-recommended-products-ui.jsx-3367411885 .price-container.jsx-3367411885 .price.jsx-3367411885{font-family:${le};color:${Qn};font-weight:700;font-size:${Ye};}`, `.container-recommended-products-ui.jsx-3367411885 .price-container.jsx-3367411885 .price.oportunidad-unica.jsx-3367411885{color:${ts};font-weight:400;}`, `.container-recommended-products-ui.jsx-3367411885 .price-container.jsx-3367411885 .price.crossed.jsx-3367411885{-webkit-text-decoration:line-through;text-decoration:line-through;color:${ns};font-weight:400;font-size:${Qe};}`];
Re.__hash = "3367411885";
const Tt = ({
  data: e,
  Badge: t
}) => /* @__PURE__ */ N(te, { children: [
  /* @__PURE__ */ f(Q, { id: Re.__hash, children: Re }),
  /* @__PURE__ */ N("div", { className: `jsx-${Re.__hash} container-recommended-products-ui`, children: [
    e.opportunidadUnica && /* @__PURE__ */ f(Vn, { width: 41, height: 20, "data-testid": "unica-cmr" }),
    /* @__PURE__ */ N("div", { className: `jsx-${Re.__hash} price-container`, children: [
      /* @__PURE__ */ N("span", { className: `jsx-${Re.__hash} ` + (ce("price", {
        crossed: e.crossed,
        "oportunidad-unica": e.opportunidadUnica
      }) || ""), children: [
        e.symbol,
        e.originalPrice
      ] }),
      t !== void 0 && t
    ] })
  ] })
] }), De = [`.badge.jsx-3188988714{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;border-radius:3px;padding:1px 4px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;font-family:${le};font-size:12px;line-height:14px;font-weight:bold;box-sizing:border-box;}`];
De.__hash = "3188988714";
const rs = (s) => {
  var r = s, {
    backgroundColor: e = "",
    textColor: t = ""
  } = r, n = ke(r, [
    "backgroundColor",
    "textColor"
  ]);
  const i = T({
    backgroundColor: e,
    color: t
  }, n.style);
  return /* @__PURE__ */ N(te, { children: [
    /* @__PURE__ */ f(Q, { id: De.__hash, children: De }),
    /* @__PURE__ */ f("span", X(T({}, n), { style: i, className: `jsx-${De.__hash} badge` }))
  ] });
}, is = ({
  prices: e,
  discountBadge: t
}) => {
  const [n, ...s] = e;
  return /* @__PURE__ */ N("div", { children: [
    /* @__PURE__ */ f(() => {
      const i = t && /* @__PURE__ */ f(rs, { backgroundColor: t.styles.backgroundColor, textColor: t.styles.textColor, children: t.label });
      return /* @__PURE__ */ f(Tt, { data: n, Badge: i });
    }, {}),
    s.map((i, o) => /* @__PURE__ */ f(Tt, { data: i }, o))
  ] });
}, fe = [".container.jsx-2849234112{position:relative;}", ".star-left.jsx-2849234112{position:absolute;}", ".star-right.jsx-2849234112{position:absolute;}"];
fe.__hash = "2849234112";
const os = (o) => {
  var a = o, {
    percentage: e,
    emptyColor: t,
    filledColor: n,
    width: s = 14,
    height: r = 13
  } = a, i = ke(a, [
    "percentage",
    "emptyColor",
    "filledColor",
    "width",
    "height"
  ]);
  const c = Math.max(0, Math.min(100, Math.round(e)));
  return /* @__PURE__ */ N(te, { children: [
    /* @__PURE__ */ f(Q, { id: fe.__hash, children: fe }),
    /* @__PURE__ */ N("div", { style: {
      width: `${s}px`,
      height: `${r}px`
    }, className: `jsx-${fe.__hash}`, children: [
      /* @__PURE__ */ f("svg", X(T({ xmlns: "http://www.w3.org/2000/svg", width: s, height: r, viewBox: "0 0 14 13", role: "img", "data-testid": `star-left-${c}`, fill: n }, i), { className: `jsx-${fe.__hash} ` + (i && i.className != null && i.className || "star-left"), children: /* @__PURE__ */ f("path", { style: {
        clipPath: `inset(0 ${100 - c}% 0 0)`
      }, d: "M13.2279 5.0701L9.00916 4.71854L7.36853 0.968536C7.30994 0.841583 7.2074 0.778107 7.06091 0.778107C6.91443 0.778107 6.81189 0.841583 6.7533 0.968536L5.09802 4.71854L0.879272 5.0701C0.732788 5.07986 0.635132 5.15311 0.586304 5.28983C0.547241 5.42654 0.581421 5.53885 0.688843 5.62674L3.89685 8.29276L2.93005 12.2625C2.90076 12.3992 2.9447 12.5115 3.06189 12.5994C3.17908 12.6775 3.30115 12.6824 3.4281 12.614L7.06091 10.5047L10.6791 12.614C10.806 12.6824 10.9281 12.6775 11.0453 12.5994C11.1722 12.5115 11.2162 12.3992 11.1771 12.2625L10.225 8.29276L13.4183 5.62674C13.5355 5.53885 13.5697 5.42654 13.5209 5.28983C13.472 5.15311 13.3744 5.07986 13.2279 5.0701Z", className: `jsx-${fe.__hash}` }) })),
      /* @__PURE__ */ f("svg", X(T({ xmlns: "http://www.w3.org/2000/svg", width: s, height: r, viewBox: "0 0 14 13", role: "img", "data-testid": `star-right-${c}`, fill: t }, i), { className: `jsx-${fe.__hash} ` + (i && i.className != null && i.className || "star-right"), children: /* @__PURE__ */ f("path", { style: {
        clipPath: `inset(0 0 0 ${c}%)`
      }, d: "M13.2279 5.0701L9.00916 4.71854L7.36853 0.968536C7.30994 0.841583 7.2074 0.778107 7.06091 0.778107C6.91443 0.778107 6.81189 0.841583 6.7533 0.968536L5.09802 4.71854L0.879272 5.0701C0.732788 5.07986 0.635132 5.15311 0.586304 5.28983C0.547241 5.42654 0.581421 5.53885 0.688843 5.62674L3.89685 8.29276L2.93005 12.2625C2.90076 12.3992 2.9447 12.5115 3.06189 12.5994C3.17908 12.6775 3.30115 12.6824 3.4281 12.614L7.06091 10.5047L10.6791 12.614C10.806 12.6824 10.9281 12.6775 11.0453 12.5994C11.1722 12.5115 11.2162 12.3992 11.1771 12.2625L10.225 8.29276L13.4183 5.62674C13.5355 5.53885 13.5697 5.42654 13.5209 5.28983C13.472 5.15311 13.3744 5.07986 13.2279 5.0701Z", className: `jsx-${fe.__hash}` }) }))
    ] })
  ] });
}, Te = [".stars.jsx-3605615881{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;gap:4px;}", ".stars.jsx-3605615881 .star-container.jsx-3605615881{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}"];
Te.__hash = "3605615881";
const as = ({
  rating: e,
  stars: t,
  emptyColor: n,
  filledColor: s
}) => {
  const r = Math.round(Math.max(t, 0)), i = Math.min(Math.max(e, 0), r), o = Array(r).fill(0).map((a, c) => c + 1 <= i ? 100 : c <= i ? (i - c) * 100 : 0);
  return /* @__PURE__ */ N(te, { children: [
    /* @__PURE__ */ f(Q, { id: Te.__hash, children: Te }),
    /* @__PURE__ */ f("div", { className: `jsx-${Te.__hash} stars`, children: o.map((a, c) => /* @__PURE__ */ f("div", { className: `jsx-${Te.__hash} star-container`, children: /* @__PURE__ */ f(os, { percentage: a, emptyColor: n, filledColor: s }) }, c)) })
  ] });
}, J = [".pod-container.jsx-381732296{padding-top:16px;padding-bottom:16px;position:relative;box-sizing:border-box;height:100%;}", ".pod-container.pills-wrapper.jsx-381732296{min-height:404px;}", `.pod-container.display-left-separator.jsx-381732296::before{--top:12%;content:'';position:absolute;top:var(--top);left:0;width:1px;border-radius:3px;background-color:${jt};height:calc(100% - 2 * var(--top));margin:auto 0;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);}`, ".link.jsx-381732296{height:100%;-webkit-text-decoration:none;text-decoration:none;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", ".pod.jsx-381732296{position:relative;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", ".image-container.jsx-381732296{width:100%;height:135px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-bottom:10px;position:relative;}", ".image-container.jsx-381732296:hover{opacity:0.5;}", ".image.jsx-381732296{width:100%;max-height:100%;height:auto;object-fit:contain;}", ".brand.jsx-381732296{margin-bottom:4px;overflow:hidden;text-wrap-mode:nowrap;text-overflow:ellipsis;}", ".name.jsx-381732296{margin-bottom:6px;}", ".prices.jsx-381732296{margin-top:7px;}", ".rating-and-reviews.jsx-381732296{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;gap:5px;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:4px;}", `.reviews.jsx-381732296{font-size:${Qe};color:${Yn};font-family:${le};}`, ".button-container.jsx-381732296{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-top:12px;padding:0 1px;-webkit-flex:1;-ms-flex:1;flex:1;-webkit-align-items:flex-end;-webkit-box-align:flex-end;-ms-flex-align:flex-end;align-items:flex-end;}", `.button.jsx-381732296{width:100%;padding:12px 5px;font-size:${Ye};font-weight:700;font-family:${le};border-radius:4px;border:1.5px solid ${mt};background:${he};color:${mt};cursor:pointer;line-height:20px;-webkit-letter-spacing:0;-moz-letter-spacing:0;-ms-letter-spacing:0;letter-spacing:0;}`, ".button.no-visible.jsx-381732296{visibility:hidden;}"];
J.__hash = "381732296";
const He = [`.brand.jsx-2325152765{text-transform:uppercase;line-height:14px;font-size:${Qe};color:${Jn};-webkit-letter-spacing:0;-moz-letter-spacing:0;-ms-letter-spacing:0;letter-spacing:0;font-family:${le};font-weight:normal;}`];
He.__hash = "2325152765";
const cs = (e) => /* @__PURE__ */ N(te, { children: [
  /* @__PURE__ */ f(Q, { id: He.__hash, children: He }),
  /* @__PURE__ */ f("span", X(T({}, e), { className: `jsx-${He.__hash} brand` }))
] }), qe = [`.name.jsx-1763816528{font-size:${Ke};font-weight:normal;line-height:16px;color:${St};height:34px;overflow:hidden;font-family:${le};display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;}`];
qe.__hash = "1763816528";
const ls = (e) => /* @__PURE__ */ N(te, { children: [
  /* @__PURE__ */ f(Q, { id: qe.__hash, children: qe }),
  /* @__PURE__ */ f("span", X(T({}, e), { className: `jsx-${qe.__hash} name` }))
] }), Pt = ({
  productData: e,
  deviceType: t,
  podButtonText: n = "",
  width: s,
  displayLeftSeparator: r,
  isProductButtonVisible: i,
  style: o,
  onProductClick: a,
  position: c,
  pillsButtonsWrapper: d = !1
}) => {
  const u = es, x = ss, S = t === "desktop", [R, h] = G(!S), _ = (g) => {
    g.preventDefault(), a == null || a(X(T({}, e), {
      position: c
    })), window.location.href = e == null ? void 0 : e.url;
  };
  return /* @__PURE__ */ N(te, { children: [
    /* @__PURE__ */ f(Q, { id: J.__hash, children: J }),
    /* @__PURE__ */ f("div", { style: o, className: `jsx-${J.__hash} ` + (ce("pod-container", {
      "display-left-separator": r,
      "pills-wrapper": d
    }) || ""), children: /* @__PURE__ */ N("a", { role: "link", href: e.url, onMouseEnter: () => S && h(!0), onMouseLeave: () => S && h(!1), style: {
      width: s
    }, onClick: _, className: `jsx-${J.__hash} link`, children: [
      /* @__PURE__ */ N("div", { className: `jsx-${J.__hash} pod`, children: [
        /* @__PURE__ */ f("div", { className: `jsx-${J.__hash} image-container`, children: /* @__PURE__ */ f("img", { src: e.mediaUrls[0], role: "img", className: `jsx-${J.__hash} image` }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${J.__hash} brand`, children: /* @__PURE__ */ f(cs, { children: e.brand }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${J.__hash} name`, children: /* @__PURE__ */ f(ls, { children: e.displayName }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${J.__hash} prices`, children: /* @__PURE__ */ f(is, { prices: e.prices, discountBadge: e.discountBadge }) }),
        /* @__PURE__ */ N("div", { className: `jsx-${J.__hash} rating-and-reviews`, children: [
          e.rating > 0 && /* @__PURE__ */ f(as, { rating: e.rating, stars: 5, emptyColor: u, filledColor: x }),
          typeof e.totalReviews == "number" && e.totalReviews > 0 && /* @__PURE__ */ N("span", { className: `jsx-${J.__hash} reviews`, children: [
            "(",
            e.totalReviews,
            ")"
          ] })
        ] })
      ] }),
      i && /* @__PURE__ */ f("div", { className: `jsx-${J.__hash} button-container`, children: /* @__PURE__ */ f("button", { className: `jsx-${J.__hash} ` + (ce("button", !R && "no-visible") || ""), children: n }) })
    ] }) })
  ] });
}, Pe = [".indicators.jsx-2739097974{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;gap:8px;}", `.bullet.jsx-2739097974{height:8px;width:8px;padding:0;margin:0;border:none;outline:none;border-radius:50%;background-color:${Xn};-webkit-transition:0.2s;transition:0.2s;}`, ".bullet.clickable.jsx-2739097974{cursor:pointer;}", `.bullet.jsx-2739097974:disabled{background-color:${Gn};cursor:initial;}`];
Pe.__hash = "2739097974";
const Ft = ({
  quantityBullets: e,
  indexActiveBullet: t,
  onClick: n
}) => {
  const s = Math.max(Math.min(t, e - 1), 0), r = new Array(e).fill(!1), i = n !== void 0;
  e > 0 && (r[s] = !0);
  const o = (a) => () => {
    i && n(a);
  };
  return /* @__PURE__ */ N(te, { children: [
    /* @__PURE__ */ f(Q, { id: Pe.__hash, children: Pe }),
    /* @__PURE__ */ f("div", { className: `jsx-${Pe.__hash} indicators`, children: r.map((a, c) => /* @__PURE__ */ f("button", { onClick: o(c), type: "button", disabled: a, "data-testid": `bullet-${c}`, className: `jsx-${Pe.__hash} ` + (ce("bullet", {
      clickable: i
    }) || "") }, c)) })
  ] });
}, ds = (e) => /* @__PURE__ */ de.createElement("svg", T({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13 24", fill: "none", stroke: "currentColor", strokeWidth: 2 }, e), /* @__PURE__ */ de.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M12 23 L1 12 L12 1" })), us = (e) => /* @__PURE__ */ de.createElement("svg", T({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13 24", fill: "none", stroke: "currentColor", strokeWidth: 2 }, e), /* @__PURE__ */ de.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M1 23 L12 12 L1 1" })), fs = 30, hs = 20, Oe = 135, cn = ({
  children: e,
  onVisible: t,
  threshold: n = 0.5,
  once: s = !1
}) => {
  const r = ee(null);
  return ae(() => {
    const i = new IntersectionObserver(([o]) => {
      o.isIntersecting && (s && i.disconnect(), t());
    }, {
      threshold: n
    });
    return i.observe(r.current), () => {
      i.disconnect();
    };
  }, []), /* @__PURE__ */ f("div", { ref: r, children: e });
}, H = [".carousel.jsx-1685098791{max-width:100%;}", `.carousel.jsx-1685098791 .white-zone.jsx-1685098791{background-color:${he};border-radius:12px;overflow:hidden;}`, `.carousel.jsx-1685098791 .title-container.jsx-1685098791{-webkit-letter-spacing:0;-moz-letter-spacing:0;-ms-letter-spacing:0;letter-spacing:0;line-height:30px;font-weight:500;border-bottom:thin solid ${jt};background-color:${he};display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-family:${le};padding:10px 40px 10px 20px;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:flex-start;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;}`, ".carousel.jsx-1685098791 .title-container.desktop.jsx-1685098791{padding:10px 40px;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}", `.carousel.jsx-1685098791 .title-container.jsx-1685098791 .title.jsx-1685098791{font-weight:400;color:${St};margin:0;font-size:${Ye};line-height:19px;}`, `.carousel.jsx-1685098791 .title-container.jsx-1685098791 .title.desktop.jsx-1685098791{font-size:${an};line-height:30px;}`, `.carousel.jsx-1685098791 .title-container.jsx-1685098791 .sponsored.jsx-1685098791{color:${Zn};font-size:${Qe};line-height:14px;font-weight:400;-webkit-letter-spacing:1px;-moz-letter-spacing:1px;-ms-letter-spacing:1px;letter-spacing:1px;margin:0;}`, ".carousel.jsx-1685098791 .body.jsx-1685098791{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}", ".carousel.jsx-1685098791 .body.jsx-1685098791 .button-container.jsx-1685098791{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:38px;}", `.carousel.jsx-1685098791 .body.jsx-1685098791 .button-container.jsx-1685098791 .button.jsx-1685098791{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;height:64px;width:34px;background-color:${he}66;cursor:pointer;border:none;color:${ut};padding:0;}`, `.carousel.jsx-1685098791 .body.jsx-1685098791 .button-container.jsx-1685098791 .button.left.jsx-1685098791{box-shadow:${ut}33 2px 0 5px -2px;margin-right:auto;}`, `.carousel.jsx-1685098791 .body.jsx-1685098791 .button-container.jsx-1685098791 .button.right.jsx-1685098791{box-shadow:${ut}33 -2px 0 5px -2px;margin-left:auto;}`, ".carousel.jsx-1685098791 .body.jsx-1685098791 .pods-wrapper.jsx-1685098791{width:100%;overflow-x:scroll;}", ".carousel.jsx-1685098791 .body.jsx-1685098791 .pods-wrapper.swipe-enabled.jsx-1685098791{overflow:hidden;}", ".carousel.jsx-1685098791 .body.jsx-1685098791 .pods-wrapper.desktop.jsx-1685098791{overflow:hidden;}", ".carousel.jsx-1685098791 .body.jsx-1685098791 .pods-wrapper.jsx-1685098791 .pods.jsx-1685098791{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:stretch;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;position:relative;left:0;-webkit-transition:left 0.5s ease-in-out;transition:left 0.5s ease-in-out;}", ".carousel.jsx-1685098791 .indicators-container.jsx-1685098791{margin-top:6px;}", ".carousel.jsx-1685098791 .indicators-container.pills-wrapper.jsx-1685098791{min-height:8px;}"];
H.__hash = "1685098791";
const ps = ({
  onSwipeLeft: e,
  onSwipeRight: t,
  threshold: n = 50
}) => {
  const s = ee(0), r = ee(0), i = ct((c) => {
    s.current = c.touches[0].clientX, r.current = c.touches[0].clientX;
  }, []), o = ct((c) => {
    r.current = c.touches[0].clientX;
  }, []), a = ct((c) => {
    var x;
    const u = (((x = c.changedTouches[0]) == null ? void 0 : x.clientX) || r.current) - s.current;
    Math.abs(u) > n && (u > 0 ? t == null || t() : e == null || e()), s.current = 0, r.current = 0;
  }, [e, t, n]);
  return {
    onTouchStart: i,
    onTouchMove: o,
    onTouchEnd: a
  };
}, ln = [{
  name: "extraLarge",
  minWidth: 1280,
  maxPods: 6,
  width: 155,
  padding: "0 48px"
}, {
  name: "large",
  minWidth: 1024,
  maxPods: 5,
  width: 142,
  padding: "0 48px"
}, {
  name: "medium",
  minWidth: 721,
  maxPods: 4,
  width: 150,
  padding: "0 48px"
}, {
  name: "small",
  minWidth: 460,
  maxPods: 3,
  width: 150,
  padding: "0 16px"
}, {
  name: "extraSmall",
  minWidth: 0,
  maxPods: 2,
  width: 150,
  padding: "0 16px"
}], ms = (e) => {
  const t = ln.find((n) => e >= n.minWidth);
  return t ? t.maxPods : 3;
}, xs = (e) => {
  const t = ln.find((n) => e >= n.minWidth);
  return t ? t.width : 150;
}, bs = ({
  labels: e = {
    title: "",
    podButtonText: "",
    sponsoredText: ""
  },
  products: t = [],
  deviceType: n = "desktop",
  isProductButtonVisible: s = !0,
  showPaginationMobile: r = !1,
  enableAutoPlay: i = {
    isEnabled: !1,
    timeout: 4e3,
    resumeDelay: 1e4
  },
  titleStyle: o = {},
  analytics: a = {},
  pillsButtonsWrapper: c = !1
}) => {
  const d = n === "desktop", u = d ? fs : hs, x = d ? 48 : 20, [S, R] = G(0), [h, _] = G(u), g = c ? x : h, [O, $] = G(Oe), [k, A] = G(1), [I, q] = G(!0), F = ee(null), L = ee(null), w = ee(null), b = t.length, y = Math.ceil(b / k), p = S === 0, m = S === y - 1, j = S * k - (m ? k - b % k : 0), C = j + k - 1, E = () => {
    q(!1), F.current && clearTimeout(F.current), F.current = window.setTimeout(() => {
      q(!0);
    }, i.resumeDelay || 5e3);
  }, V = (M) => {
    var P;
    (P = a == null ? void 0 : a.onChangePage) == null || P.call(a, M), R(M), q(!1), E();
  }, D = () => {
    const M = w.current.clientWidth, P = Math.max(1, Math.trunc(M / (Oe + u))), Y = M - P * (Oe + u), je = u + Y / P;
    _(je), A(P), R(0);
  }, ye = () => {
    m || V(S + 1);
  }, it = () => {
    p || V(S - 1);
  }, ne = r && !d, ue = ps({
    onSwipeLeft: ye,
    onSwipeRight: it
  }), Ne = ne ? ue : {};
  ae(() => {
    var Y;
    if (!(L != null && L.current) || !c) return;
    const M = (Y = L == null ? void 0 : L.current) == null ? void 0 : Y.clientWidth, P = xs(M);
    $(P);
  }, [c]), ae(() => {
    var P;
    (P = a.onRender) == null || P.call(a);
    const M = new ResizeObserver(D);
    return M.observe(L.current), () => {
      M.disconnect();
    };
  }, []), ae(() => {
    R(0);
  }, [t]), ae(() => {
    if (i.isEnabled && I) {
      const M = setInterval(() => {
        R((P) => {
          var je;
          const Y = (P + 1) % y;
          return (je = a == null ? void 0 : a.onChangePage) == null || je.call(a, Y), Y;
        });
      }, i.timeout);
      return () => clearInterval(M);
    }
  }, [i.isEnabled, i.timeout, y, I]), ae(() => {
    D();
  }, []), ae(() => () => {
    F.current && clearTimeout(F.current);
  }, []);
  const _e = () => {
    V(Math.max(0, S - 1)), i.isEnabled && (q(!1), E());
  }, Me = () => {
    V(Math.min(S + 1, y - 1)), i.isEnabled && (q(!1), E());
  }, Fn = () => {
    if (p) return "0px";
    const M = g + O;
    if (m) {
      const Y = b - S * k, je = k - Y;
      return `${-((S * k - je) * M)}px`;
    }
    return `${-(S * k * M)}px`;
  };
  return /* @__PURE__ */ N(te, { children: [
    /* @__PURE__ */ f(Q, { id: H.__hash, children: H }),
    /* @__PURE__ */ N("div", { ref: L, className: `jsx-${H.__hash} carousel`, children: [
      /* @__PURE__ */ N("div", { className: `jsx-${H.__hash} white-zone`, children: [
        e.title && /* @__PURE__ */ N("div", { className: `jsx-${H.__hash} ` + (ce("title-container", {
          desktop: d
        }) || ""), children: [
          /* @__PURE__ */ f("h2", { style: o, className: `jsx-${H.__hash} ` + (ce("title", {
            desktop: d
          }) || ""), children: e.title }),
          /* @__PURE__ */ f("h2", { className: `jsx-${H.__hash} sponsored`, children: e.sponsoredText })
        ] }),
        /* @__PURE__ */ N("div", { className: `jsx-${H.__hash} body`, children: [
          d && /* @__PURE__ */ f("div", { className: `jsx-${H.__hash} button-container`, children: S > 0 && /* @__PURE__ */ f("button", { onClick: _e, "data-testid": "button-left", className: `jsx-${H.__hash} button left`, children: /* @__PURE__ */ f(ds, { width: 8, height: 14 }) }) }),
          /* @__PURE__ */ f("div", X(T({}, Ne), { className: `jsx-${H.__hash} ` + (ce("pods-wrapper", {
            desktop: d,
            "swipe-enabled": ne
          }) || ""), children: /* @__PURE__ */ f("div", { ref: w, style: {
            left: Fn()
          }, className: `jsx-${H.__hash} pods`, children: t.map((M, P) => /* @__PURE__ */ f(sn.Fragment, { children: a.onProductImpression ? /* @__PURE__ */ f(cn, { onVisible: () => {
            var Y;
            return (Y = a == null ? void 0 : a.onProductImpression) == null ? void 0 : Y.call(a, M, P);
          }, once: !0, children: /* @__PURE__ */ f(Pt, { position: P + 1, productData: M, deviceType: n, podButtonText: e.podButtonText, isProductButtonVisible: s, width: `${Oe}px`, displayLeftSeparator: d ? j !== P && C !== P - 1 : P !== 0, style: {
            paddingLeft: `${h / 2}px`,
            paddingRight: `${h / 2}px`
          }, onProductClick: a == null ? void 0 : a.onProductClick, pillsButtonsWrapper: c }) }) : /* @__PURE__ */ f("div", { className: `jsx-${H.__hash}`, children: /* @__PURE__ */ f(Pt, { position: P + 1, productData: M, deviceType: n, podButtonText: e.podButtonText, isProductButtonVisible: s, width: `${Oe}px`, displayLeftSeparator: d ? j !== P && C !== P - 1 : P !== 0, style: {
            paddingLeft: `${h / 2}px`,
            paddingRight: `${h / 2}px`
          }, onProductClick: a == null ? void 0 : a.onProductClick, pillsButtonsWrapper: c }) }) }, `pod-${P}`)) }) })),
          d && /* @__PURE__ */ f("div", { className: `jsx-${H.__hash} button-container`, children: S < y - 1 && /* @__PURE__ */ f("button", { onClick: Me, "data-testid": "button-right", className: `jsx-${H.__hash} button right`, children: /* @__PURE__ */ f(us, { width: 8, height: 14 }) }) })
        ] })
      ] }),
      /* @__PURE__ */ N("div", { className: `jsx-${H.__hash} ` + (ce("indicators-container", {
        "pills-wrapper": c
      }) || ""), children: [
        d && !r && y > 1 && /* @__PURE__ */ f(Ft, { quantityBullets: y, indexActiveBullet: S, onClick: V }),
        !d && r && y > 1 && /* @__PURE__ */ f(Ft, { quantityBullets: y, indexActiveBullet: S, onClick: V })
      ] })
    ] })
  ] });
}, Ve = [`.skeleton-shimmer.jsx-4121441802{width:100%;height:100%;background-color:${dt};position:relative;overflow:hidden;}`, `.skeleton-shimmer.jsx-4121441802::before{content:'';position:absolute;top:0;left:-150%;width:150%;height:100%;background:linear-gradient( 90deg, ${dt} 0.01%, ${Kn} 49.5%, ${dt} 100% );-webkit-animation:skeleton-loading-jsx-4121441802 1.5s infinite;animation:skeleton-loading-jsx-4121441802 1.5s infinite;}`, "@-webkit-keyframes skeleton-loading-jsx-4121441802{0%{left:-150%;}100%{left:100%;}}", "@keyframes skeleton-loading-jsx-4121441802{0%{left:-150%;}100%{left:100%;}}"];
Ve.__hash = "4121441802";
const se = (e) => /* @__PURE__ */ N(te, { children: [
  /* @__PURE__ */ f(Q, { id: Ve.__hash, children: Ve }),
  /* @__PURE__ */ f("div", X(T({ "data-testid": "skeleton-shimmer" }, e), { className: `jsx-${Ve.__hash} skeleton-shimmer` }))
] }), We = 135, z = [".carousel.jsx-3433894198{width:100%;}", `.carousel.jsx-3433894198 .white-zone.jsx-3433894198{background-color:${he};border-radius:12px;overflow:hidden;}`, `.carousel.jsx-3433894198 .title-container.jsx-3433894198{padding:10px 40px;border-bottom:thin solid ${jt};}`, ".carousel.jsx-3433894198 .title-container.jsx-3433894198 .title.jsx-3433894198{height:30px;width:60%;}", ".carousel.jsx-3433894198 .body.jsx-3433894198{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;max-width:100%;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:space-around;-webkit-justify-content:space-around;-ms-flex-pack:space-around;justify-content:space-around;-webkit-align-items:stretch;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;}", `.carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198{width:${We}px;padding:16px 0;}`, `.carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .image-container.jsx-3433894198 .image.jsx-3433894198{width:${We}px;height:${We}px;position:relative;}`, ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .brand.jsx-3433894198{margin-top:4px;width:30%;height:12px;position:relative;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .name-1.jsx-3433894198{margin-top:4px;width:100%;height:14px;position:relative;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .name-2.jsx-3433894198{margin-top:2px;width:75%;height:14px;position:relative;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .price-1.jsx-3433894198{margin-top:8px;width:70%;height:22px;position:relative;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .price-2.jsx-3433894198{margin-top:3px;width:60%;height:20px;position:relative;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .price-3.jsx-3433894198{margin-top:3px;width:30%;height:17px;position:relative;}", ".carousel.jsx-3433894198 .body.jsx-3433894198 .pods.jsx-3433894198 .pod.jsx-3433894198 .rating.jsx-3433894198{margin-top:8px;width:90%;height:10px;position:relative;}"];
z.__hash = "3433894198";
const dn = ({
  isPillsButton: e = !1
}) => {
  const [t, n] = G(0), s = ee(null), r = ee(null);
  return ae(() => {
    if (!r.current && e) return;
    let i = 6;
    if (e) {
      const c = r.current.clientWidth;
      i = ms(c);
    }
    const o = s.current.clientWidth, a = e ? i : Math.max(2, Math.trunc(o / We) - 1);
    n(a);
  }, []), /* @__PURE__ */ N(te, { children: [
    /* @__PURE__ */ f(Q, { id: z.__hash, children: z }),
    /* @__PURE__ */ f("div", { "data-testid": "skeleton-carousel", ref: r, className: `jsx-${z.__hash} carousel`, children: /* @__PURE__ */ N("div", { className: `jsx-${z.__hash} white-zone`, children: [
      !e && /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} title-container`, children: /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} title`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }) }),
      /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} body`, children: /* @__PURE__ */ f("div", { ref: s, className: `jsx-${z.__hash} pods`, children: Array.from({
        length: t
      }, (i, o) => /* @__PURE__ */ N("div", { className: `jsx-${z.__hash} pod`, children: [
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} image-container`, children: /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} image`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} brand`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} name-1`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} name-2`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} price-1`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} price-2`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} price-3`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) }),
        /* @__PURE__ */ f("div", { className: `jsx-${z.__hash} rating`, children: /* @__PURE__ */ f(se, { "data-testid": "skeleton-bar" }) })
      ] }, `pod-${o}`)) }) })
    ] }) })
  ] });
}, si = (n) => {
  var s = n, {
    showSkeleton: e = !1
  } = s, t = ke(s, [
    "showSkeleton"
  ]);
  var r;
  return e ? /* @__PURE__ */ f(dn, {}) : (r = t.products) != null && r.length ? /* @__PURE__ */ f(bs, T({}, t)) : null;
}, B = [`.pills-button-wrapper.jsx-2358717582 *.jsx-2358717582{box-sizing:border-box;font-family:${le};}`, `.pills-button-wrapper.jsx-2358717582{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;background-color:${he};-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:12px 0;border-radius:4px;}`, ".header-container.jsx-2358717582{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;width:100%;overflow:hidden;}", ".title-container.jsx-2358717582{padding-inline:48px;}", ".skeleton-title-container.jsx-2358717582{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}", ".pills-skeleton-body.jsx-2358717582{height:370px;}", ".skeleton-title.jsx-2358717582{width:60%;height:30px;}", `.title.jsx-2358717582{font-size:${an};font-weight:700;line-height:28px;font-family:${le};margin-block:0 16px;}`, ".pills-button-container.jsx-2358717582{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding-inline:48px;}", ".tabs-container.jsx-2358717582{overflow-x:auto;}", ".tabs-container.jsx-2358717582::-webkit-scrollbar{width:8px;cursor:pointer;}", `.tabs.jsx-2358717582{background-color:${Wn};display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;padding:4px;border-radius:16px;gap:8px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;height:36px;overflow:hidden;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;}`, `.pill-button.jsx-2358717582{background-color:transparent;cursor:pointer;border:none;padding:4px 20px;font-size:${Ke};height:28px;text-wrap-mode:nowrap;text-align:center;}`, `.pill-button.active.jsx-2358717582{background-color:${he};border-radius:12px;}`, ".pills-body.jsx-2358717582{width:inherit;}", ".pills-body-standalone.jsx-2358717582{height:370px;position:relative;}", ".pills-body-skeleton.jsx-2358717582{min-height:418px;}", ".skeleton-buttons-container.jsx-2358717582{width:100%;margin:16px 0;padding:0 16px;}", ".skeleton-buttons.jsx-2358717582{width:100%;height:32px;}", ".footer-container.jsx-2358717582{width:100%;height:32px;}", `.know-more-button.jsx-2358717582{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;justify-self:end;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:4px 32px;color:${mt};font-size:${Ke};font-weight:700;line-height:20px;-webkit-text-decoration:underline;text-decoration:underline;text-underline-offset:4px;height:32px;}`, `@media (width <= ${on}){.tabs.jsx-2358717582{-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;}}`, "@media (width <= 460px){.title-container.jsx-2358717582{padding-inline:16px;}.pills-button-container.jsx-2358717582{padding-inline:16px;}}"];
B.__hash = "2358717582";
const ri = ({
  tabs: e = [],
  children: t = null,
  showMore: n = !1,
  onClickGroupId: s = () => {
  },
  selectedGroupId: r = "",
  labels: i = {},
  variant: o = "",
  isLoading: a = !1,
  isFirstLoad: c = !1,
  lazyLoad: d = !1,
  onVisible: u = () => {
  },
  analytics: x = {}
}) => {
  const [S, R] = G(!d), h = ee(null), _ = ee(null), g = () => {
    R(!0), u();
  }, O = (k, A) => {
    var I;
    s(k == null ? void 0 : k.groupId), (I = x == null ? void 0 : x.onClick) == null || I.call(x, X(T({}, k), {
      position: A
    }));
  }, $ = /* @__PURE__ */ N("div", { ref: h, className: `jsx-${B.__hash} pills-button-wrapper`, children: [
    /* @__PURE__ */ N("div", { className: `jsx-${B.__hash} header-container`, children: [
      c ? /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} skeleton-title-container`, children: /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} skeleton-title`, children: /* @__PURE__ */ f(se, {}) }) }) : /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} title-container`, children: /* @__PURE__ */ f("h2", { className: `jsx-${B.__hash} title`, children: i == null ? void 0 : i.title }) }),
      c ? /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} skeleton-buttons-container`, children: /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} skeleton-buttons`, children: /* @__PURE__ */ f(se, {}) }) }) : /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} pills-button-container`, children: /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} tabs-container`, children: /* @__PURE__ */ f("div", { ref: _, className: `jsx-${B.__hash} ` + (ce("tabs") || ""), children: e.map((k, A) => /* @__PURE__ */ f("button", { onClick: () => O(k, A + 1), className: `jsx-${B.__hash} pill-button ${r === (k == null ? void 0 : k.groupId) ? "active" : ""}`, children: k == null ? void 0 : k.groupName }, `${k.groupId}-${A}`)) }) }) })
    ] }),
    /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} ` + (ce(`pills-body pills-body-${o}`) || ""), children: a ? /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} pills-body-skeleton`, children: /* @__PURE__ */ f(dn, { isPillsButton: !0 }) }) : t }),
    /* @__PURE__ */ f("div", { className: `jsx-${B.__hash} footer-container`, children: n && /* @__PURE__ */ f("a", { href: i == null ? void 0 : i.knowMoreUrl, className: `jsx-${B.__hash} know-more-button`, children: i == null ? void 0 : i.knowMoreText }) }),
    /* @__PURE__ */ f(Q, { id: B.__hash, children: B })
  ] });
  return !c && !(e != null && e.length) ? /* @__PURE__ */ f("div", { "data-testid": "pills-button-empty-groups" }) : !d || S ? $ : /* @__PURE__ */ f(cn, { onVisible: g, once: !0, threshold: 0.2, children: $ });
}, xe = [`.empty-state.jsx-2524009963{background:${he};width:100%;}`, ".empty-state__body.jsx-2524009963{text-align:center;min-height:322px;}", ".empty-state__body.jsx-2524009963>img.jsx-2524009963{width:320px;aspect-ratio:8/7;margin:0 auto;}", `.empty-state__body.jsx-2524009963>h2.jsx-2524009963{text-align:center;margin-block:0;margin-inline:auto;font-size:${Ye};line-height:24px;font-weight:400;font-family:${le};width:50%;}`, `.empty-state__body.jsx-2524009963 a.jsx-2524009963{color:${St};}`, `@media (width <= ${on}){.empty-state__body.jsx-2524009963>h2.jsx-2524009963{font-size:${Ke};line-height:20px;padding-inline:16px;width:auto;}}`];
xe.__hash = "2524009963";
const ii = ({
  children: e,
  height: t,
  image: n
}) => /* @__PURE__ */ N(te, { children: [
  /* @__PURE__ */ f(Q, { id: xe.__hash, children: xe }),
  /* @__PURE__ */ f("div", { style: {
    height: t
  }, className: `jsx-${xe.__hash} empty-state`, children: /* @__PURE__ */ N("article", { className: `jsx-${xe.__hash} empty-state__body`, children: [
    /* @__PURE__ */ f("img", { src: n.src, alt: n.alt, loading: n.loading || "lazy", decoding: n.decoding || "async", className: `jsx-${xe.__hash}` }),
    /* @__PURE__ */ f("h2", { className: `jsx-${xe.__hash}`, children: e })
  ] }) })
] }), me = {
  SODIMAC_CL: "sodimac-cl",
  HOMECENTER_CO: "homecenter-co",
  SODIMAC_AR: "sodimac-ar",
  SODIMAC_PE: "sodimac-pe",
  SODIMAC_UY: "sodimac-uy",
  SODIMAC_BR: "sodimac-br",
  SODIMAC_MX: "sodimac-mx"
}, xt = {
  channels: {
    WEB: "web"
  },
  tenants: {
    [me.SODIMAC_CL]: {
      siteId: "socl",
      prefix: ""
    },
    [me.SODIMAC_PE]: {
      siteId: "sope",
      prefix: "pe"
    },
    [me.SODIMAC_MX]: {
      siteId: "somx",
      prefix: "mx"
    },
    [me.HOMECENTER_CO]: {
      siteId: "soco",
      prefix: "co"
    },
    [me.SODIMAC_AR]: {
      siteId: "soar",
      prefix: "ar"
    },
    [me.SODIMAC_UY]: {
      siteId: "souy",
      prefix: "uy"
    },
    [me.SODIMAC_BR]: {
      siteId: "sobr",
      prefix: "br"
    }
  },
  groupType: {
    BRAND: "brand",
    CATEGORY: "category"
  }
}, Lt = () => typeof window != "undefined", gs = (e) => e === "cl" || !e ? "" : `.${e}`, ws = (e, t) => {
  const s = /sodimac\.(cl|com\.pe)/.test(e), r = gs(t);
  if (e.includes("localhost"))
    return `https://beta.falabella.com${r}`;
  if (s) {
    const i = e.replace("https://", "").split(".")[0];
    return `https://${i === "sodimac" ? "www" : i}.falabella.com${r}`;
  }
  return e;
}, It = (e = {}) => {
  const t = new URLSearchParams();
  return Object.entries(e).forEach(([n, s]) => {
    s && t.append(n, String(s));
  }), t.toString();
}, Ut = ({
  data: e,
  isStandaloneSite: t,
  minTabs: n,
  maxTabs: s
}) => {
  var i, o, a;
  const r = {
    carouselName: "",
    products: [],
    groups: []
  };
  if (!e || typeof e != "object" || ((i = Object.keys(e)) == null ? void 0 : i.length) === 0)
    return r;
  if (t) {
    const {
      widgets: c,
      groups: d
    } = e;
    r.carouselName = ((o = c == null ? void 0 : c[0]) == null ? void 0 : o.name) || "", r.products = ((a = c == null ? void 0 : c[0]) == null ? void 0 : a.data) || [], r.groups = d || [];
  } else {
    const {
      products: c,
      groups: d,
      carouselName: u
    } = e;
    r.carouselName = u || "", r.products = c || [], r.groups = d || [];
  }
  return r.groups.length < n && (r.groups = []), r.groups = r.groups.slice(0, s).map((c) => {
    var d, u;
    return X(T({}, c), {
      catalogGroupId: (u = (d = c == null ? void 0 : c.groupId) == null ? void 0 : d.split("_")) == null ? void 0 : u[0],
      rawGroupName: c == null ? void 0 : c.groupName
    });
  }), r;
}, ys = (e, t) => e.includes("localhost") ? t === "co" ? "https://www.homecenter.com.co" : `https://beta.sodimac.com.${t}` : e, Mt = {
  getRecoDataAndes: (e) => {
    const a = e, {
      regionCode: t = "cl"
    } = a, n = ke(a, [
      "regionCode"
    ]), s = Lt() ? window.location.origin : "", r = ws(s, t), i = T({}, n), o = It(i);
    return `${r}/s/browse/v2/recommended-products/${t}?${o}`;
  },
  getRecoDataNonAndes: (e) => {
    var k, A;
    const $ = e, {
      tenantId: t = "",
      userId: n,
      contextId: s,
      position: r,
      pageType: i,
      noCache: o,
      groupId: a
    } = $, c = ke($, [
      "tenantId",
      "userId",
      "contextId",
      "position",
      "pageType",
      "noCache",
      "groupId"
    ]), {
      channels: d,
      tenants: u
    } = xt, x = T({
      channel: d.WEB,
      position: r || "",
      origin: i,
      noCache: o || null,
      userId: n,
      contextId: s,
      groupId: a || ""
    }, c), S = Lt() ? window.location.origin : "", R = It(x), h = (k = u[t]) == null ? void 0 : k.siteId, _ = (A = u[t]) == null ? void 0 : A.prefix;
    return `${ys(S, _)}/s/products/v2/${h}/recommendations?${R}`;
  }
};
function un(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: _s } = Object.prototype, { getPrototypeOf: kt } = Object, { iterator: et, toStringTag: fn } = Symbol, tt = /* @__PURE__ */ ((e) => (t) => {
  const n = _s.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), re = (e) => (e = e.toLowerCase(), (t) => tt(t) === e), nt = (e) => (t) => typeof t === e, { isArray: Ee } = Array, ve = nt("undefined");
function Fe(e) {
  return e !== null && !ve(e) && e.constructor !== null && !ve(e.constructor) && K(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const hn = re("ArrayBuffer");
function js(e) {
  let t;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && hn(e.buffer), t;
}
const Ss = nt("string"), K = nt("function"), pn = nt("number"), Le = (e) => e !== null && typeof e == "object", ks = (e) => e === !0 || e === !1, Je = (e) => {
  if (tt(e) !== "object")
    return !1;
  const t = kt(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(fn in e) && !(et in e);
}, Cs = (e) => {
  if (!Le(e) || Fe(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch (t) {
    return !1;
  }
}, Rs = re("Date"), vs = re("File"), Es = re("Blob"), $s = re("FileList"), Ns = (e) => Le(e) && K(e.pipe), Os = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || K(e.append) && ((t = tt(e)) === "formdata" || // detect form-data instance
  t === "object" && K(e.toString) && e.toString() === "[object FormData]"));
}, As = re("URLSearchParams"), [Ts, Ps, Fs, Ls] = ["ReadableStream", "Request", "Response", "Headers"].map(re), Is = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ie(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e == "undefined")
    return;
  let s, r;
  if (typeof e != "object" && (e = [e]), Ee(e))
    for (s = 0, r = e.length; s < r; s++)
      t.call(null, e[s], s, e);
  else {
    if (Fe(e))
      return;
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let a;
    for (s = 0; s < o; s++)
      a = i[s], t.call(null, e[a], a, e);
  }
}
function mn(e, t) {
  if (Fe(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let s = n.length, r;
  for (; s-- > 0; )
    if (r = n[s], t === r.toLowerCase())
      return r;
  return null;
}
const be = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global, xn = (e) => !ve(e) && e !== be;
function bt() {
  const { caseless: e, skipUndefined: t } = xn(this) && this || {}, n = {}, s = (r, i) => {
    const o = e && mn(n, i) || i;
    Je(n[o]) && Je(r) ? n[o] = bt(n[o], r) : Je(r) ? n[o] = bt({}, r) : Ee(r) ? n[o] = r.slice() : (!t || !ve(r)) && (n[o] = r);
  };
  for (let r = 0, i = arguments.length; r < i; r++)
    arguments[r] && Ie(arguments[r], s);
  return n;
}
const Us = (e, t, n, { allOwnKeys: s } = {}) => (Ie(t, (r, i) => {
  n && K(r) ? e[i] = un(r, n) : e[i] = r;
}, { allOwnKeys: s }), e), Ms = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), zs = (e, t, n, s) => {
  e.prototype = Object.create(t.prototype, s), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Bs = (e, t, n, s) => {
  let r, i, o;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (r = Object.getOwnPropertyNames(e), i = r.length; i-- > 0; )
      o = r[i], (!s || s(o, e, t)) && !a[o] && (t[o] = e[o], a[o] = !0);
    e = n !== !1 && kt(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Ds = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const s = e.indexOf(t, n);
  return s !== -1 && s === n;
}, Hs = (e) => {
  if (!e) return null;
  if (Ee(e)) return e;
  let t = e.length;
  if (!pn(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, qs = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array != "undefined" && kt(Uint8Array)), Vs = (e, t) => {
  const s = (e && e[et]).call(e);
  let r;
  for (; (r = s.next()) && !r.done; ) {
    const i = r.value;
    t.call(e, i[0], i[1]);
  }
}, Ws = (e, t) => {
  let n;
  const s = [];
  for (; (n = e.exec(t)) !== null; )
    s.push(n);
  return s;
}, Js = re("HTMLFormElement"), Xs = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, s, r) {
    return s.toUpperCase() + r;
  }
), zt = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Gs = re("RegExp"), bn = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), s = {};
  Ie(n, (r, i) => {
    let o;
    (o = t(r, i, e)) !== !1 && (s[i] = o || r);
  }), Object.defineProperties(e, s);
}, Ks = (e) => {
  bn(e, (t, n) => {
    if (K(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const s = e[n];
    if (K(s)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Zs = (e, t) => {
  const n = {}, s = (r) => {
    r.forEach((i) => {
      n[i] = !0;
    });
  };
  return Ee(e) ? s(e) : s(String(e).split(t)), n;
}, Qs = () => {
}, Ys = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function er(e) {
  return !!(e && K(e.append) && e[fn] === "FormData" && e[et]);
}
const tr = (e) => {
  const t = new Array(10), n = (s, r) => {
    if (Le(s)) {
      if (t.indexOf(s) >= 0)
        return;
      if (Fe(s))
        return s;
      if (!("toJSON" in s)) {
        t[r] = s;
        const i = Ee(s) ? [] : {};
        return Ie(s, (o, a) => {
          const c = n(o, r + 1);
          !ve(c) && (i[a] = c);
        }), t[r] = void 0, i;
      }
    }
    return s;
  };
  return n(e, 0);
}, nr = re("AsyncFunction"), sr = (e) => e && (Le(e) || K(e)) && K(e.then) && K(e.catch), gn = ((e, t) => e ? setImmediate : t ? ((n, s) => (be.addEventListener("message", ({ source: r, data: i }) => {
  r === be && i === n && s.length && s.shift()();
}, !1), (r) => {
  s.push(r), be.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  K(be.postMessage)
), rr = typeof queueMicrotask != "undefined" ? queueMicrotask.bind(be) : typeof process != "undefined" && process.nextTick || gn, ir = (e) => e != null && K(e[et]), l = {
  isArray: Ee,
  isArrayBuffer: hn,
  isBuffer: Fe,
  isFormData: Os,
  isArrayBufferView: js,
  isString: Ss,
  isNumber: pn,
  isBoolean: ks,
  isObject: Le,
  isPlainObject: Je,
  isEmptyObject: Cs,
  isReadableStream: Ts,
  isRequest: Ps,
  isResponse: Fs,
  isHeaders: Ls,
  isUndefined: ve,
  isDate: Rs,
  isFile: vs,
  isBlob: Es,
  isRegExp: Gs,
  isFunction: K,
  isStream: Ns,
  isURLSearchParams: As,
  isTypedArray: qs,
  isFileList: $s,
  forEach: Ie,
  merge: bt,
  extend: Us,
  trim: Is,
  stripBOM: Ms,
  inherits: zs,
  toFlatObject: Bs,
  kindOf: tt,
  kindOfTest: re,
  endsWith: Ds,
  toArray: Hs,
  forEachEntry: Vs,
  matchAll: Ws,
  isHTMLForm: Js,
  hasOwnProperty: zt,
  hasOwnProp: zt,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: bn,
  freezeMethods: Ks,
  toObjectSet: Zs,
  toCamelCase: Xs,
  noop: Qs,
  toFiniteNumber: Ys,
  findKey: mn,
  global: be,
  isContextDefined: xn,
  isSpecCompliantForm: er,
  toJSONObject: tr,
  isAsyncFn: nr,
  isThenable: sr,
  setImmediate: gn,
  asap: rr,
  isIterable: ir
};
function v(e, t, n, s, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), s && (this.request = s), r && (this.response = r, this.status = r.status ? r.status : null);
}
l.inherits(v, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: l.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const wn = v.prototype, yn = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  yn[e] = { value: e };
});
Object.defineProperties(v, yn);
Object.defineProperty(wn, "isAxiosError", { value: !0 });
v.from = (e, t, n, s, r, i) => {
  const o = Object.create(wn);
  l.toFlatObject(e, o, function(u) {
    return u !== Error.prototype;
  }, (d) => d !== "isAxiosError");
  const a = e && e.message ? e.message : "Error", c = t == null && e ? e.code : t;
  return v.call(o, a, c, n, s, r), e && o.cause == null && Object.defineProperty(o, "cause", { value: e, configurable: !0 }), o.name = e && e.name || "Error", i && Object.assign(o, i), o;
};
const or = null;
function gt(e) {
  return l.isPlainObject(e) || l.isArray(e);
}
function _n(e) {
  return l.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Bt(e, t, n) {
  return e ? e.concat(t).map(function(r, i) {
    return r = _n(r), !n && i ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
function ar(e) {
  return l.isArray(e) && !e.some(gt);
}
const cr = l.toFlatObject(l, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function st(e, t, n) {
  if (!l.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = l.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(_, g) {
    return !l.isUndefined(g[_]);
  });
  const s = n.metaTokens, r = n.visitor || u, i = n.dots, o = n.indexes, c = (n.Blob || typeof Blob != "undefined" && Blob) && l.isSpecCompliantForm(t);
  if (!l.isFunction(r))
    throw new TypeError("visitor must be a function");
  function d(h) {
    if (h === null) return "";
    if (l.isDate(h))
      return h.toISOString();
    if (l.isBoolean(h))
      return h.toString();
    if (!c && l.isBlob(h))
      throw new v("Blob is not supported. Use a Buffer instead.");
    return l.isArrayBuffer(h) || l.isTypedArray(h) ? c && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function u(h, _, g) {
    let O = h;
    if (h && !g && typeof h == "object") {
      if (l.endsWith(_, "{}"))
        _ = s ? _ : _.slice(0, -2), h = JSON.stringify(h);
      else if (l.isArray(h) && ar(h) || (l.isFileList(h) || l.endsWith(_, "[]")) && (O = l.toArray(h)))
        return _ = _n(_), O.forEach(function(k, A) {
          !(l.isUndefined(k) || k === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Bt([_], A, i) : o === null ? _ : _ + "[]",
            d(k)
          );
        }), !1;
    }
    return gt(h) ? !0 : (t.append(Bt(g, _, i), d(h)), !1);
  }
  const x = [], S = Object.assign(cr, {
    defaultVisitor: u,
    convertValue: d,
    isVisitable: gt
  });
  function R(h, _) {
    if (!l.isUndefined(h)) {
      if (x.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + _.join("."));
      x.push(h), l.forEach(h, function(O, $) {
        (!(l.isUndefined(O) || O === null) && r.call(
          t,
          O,
          l.isString($) ? $.trim() : $,
          _,
          S
        )) === !0 && R(O, _ ? _.concat($) : [$]);
      }), x.pop();
    }
  }
  if (!l.isObject(e))
    throw new TypeError("data must be an object");
  return R(e), t;
}
function Dt(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(s) {
    return t[s];
  });
}
function Ct(e, t) {
  this._pairs = [], e && st(e, this, t);
}
const jn = Ct.prototype;
jn.append = function(t, n) {
  this._pairs.push([t, n]);
};
jn.toString = function(t) {
  const n = t ? function(s) {
    return t.call(this, s, Dt);
  } : Dt;
  return this._pairs.map(function(r) {
    return n(r[0]) + "=" + n(r[1]);
  }, "").join("&");
};
function lr(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Sn(e, t, n) {
  if (!t)
    return e;
  const s = n && n.encode || lr;
  l.isFunction(n) && (n = {
    serialize: n
  });
  const r = n && n.serialize;
  let i;
  if (r ? i = r(t, n) : i = l.isURLSearchParams(t) ? t.toString() : new Ct(t, n).toString(s), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Ht {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, s) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    l.forEach(this.handlers, function(s) {
      s !== null && t(s);
    });
  }
}
const kn = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, dr = typeof URLSearchParams != "undefined" ? URLSearchParams : Ct, ur = typeof FormData != "undefined" ? FormData : null, fr = typeof Blob != "undefined" ? Blob : null, hr = {
  isBrowser: !0,
  classes: {
    URLSearchParams: dr,
    FormData: ur,
    Blob: fr
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Rt = typeof window != "undefined" && typeof document != "undefined", wt = typeof navigator == "object" && navigator || void 0, pr = Rt && (!wt || ["ReactNative", "NativeScript", "NS"].indexOf(wt.product) < 0), mr = typeof WorkerGlobalScope != "undefined" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", xr = Rt && window.location.href || "http://localhost", br = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Rt,
  hasStandardBrowserEnv: pr,
  hasStandardBrowserWebWorkerEnv: mr,
  navigator: wt,
  origin: xr
}, Symbol.toStringTag, { value: "Module" })), W = T(T({}, br), hr);
function gr(e, t) {
  return st(e, new W.classes.URLSearchParams(), T({
    visitor: function(n, s, r, i) {
      return W.isNode && l.isBuffer(n) ? (this.append(s, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function wr(e) {
  return l.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function yr(e) {
  const t = {}, n = Object.keys(e);
  let s;
  const r = n.length;
  let i;
  for (s = 0; s < r; s++)
    i = n[s], t[i] = e[i];
  return t;
}
function Cn(e) {
  function t(n, s, r, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), c = i >= n.length;
    return o = !o && l.isArray(r) ? r.length : o, c ? (l.hasOwnProp(r, o) ? r[o] = [r[o], s] : r[o] = s, !a) : ((!r[o] || !l.isObject(r[o])) && (r[o] = []), t(n, s, r[o], i) && l.isArray(r[o]) && (r[o] = yr(r[o])), !a);
  }
  if (l.isFormData(e) && l.isFunction(e.entries)) {
    const n = {};
    return l.forEachEntry(e, (s, r) => {
      t(wr(s), r, n, 0);
    }), n;
  }
  return null;
}
function _r(e, t, n) {
  if (l.isString(e))
    try {
      return (t || JSON.parse)(e), l.trim(e);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (n || JSON.stringify)(e);
}
const Ue = {
  transitional: kn,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const s = n.getContentType() || "", r = s.indexOf("application/json") > -1, i = l.isObject(t);
    if (i && l.isHTMLForm(t) && (t = new FormData(t)), l.isFormData(t))
      return r ? JSON.stringify(Cn(t)) : t;
    if (l.isArrayBuffer(t) || l.isBuffer(t) || l.isStream(t) || l.isFile(t) || l.isBlob(t) || l.isReadableStream(t))
      return t;
    if (l.isArrayBufferView(t))
      return t.buffer;
    if (l.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (i) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return gr(t, this.formSerializer).toString();
      if ((a = l.isFileList(t)) || s.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return st(
          a ? { "files[]": t } : t,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return i || r ? (n.setContentType("application/json", !1), _r(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Ue.transitional, s = n && n.forcedJSONParsing, r = this.responseType === "json";
    if (l.isResponse(t) || l.isReadableStream(t))
      return t;
    if (t && l.isString(t) && (s && !this.responseType || r)) {
      const o = !(n && n.silentJSONParsing) && r;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? v.from(a, v.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: W.classes.FormData,
    Blob: W.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
l.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Ue.headers[e] = {};
});
const jr = l.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Sr = (e) => {
  const t = {};
  let n, s, r;
  return e && e.split(`
`).forEach(function(o) {
    r = o.indexOf(":"), n = o.substring(0, r).trim().toLowerCase(), s = o.substring(r + 1).trim(), !(!n || t[n] && jr[n]) && (n === "set-cookie" ? t[n] ? t[n].push(s) : t[n] = [s] : t[n] = t[n] ? t[n] + ", " + s : s);
  }), t;
}, qt = Symbol("internals");
function Ae(e) {
  return e && String(e).trim().toLowerCase();
}
function Xe(e) {
  return e === !1 || e == null ? e : l.isArray(e) ? e.map(Xe) : String(e);
}
function kr(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = n.exec(e); )
    t[s[1]] = s[2];
  return t;
}
const Cr = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ft(e, t, n, s, r) {
  if (l.isFunction(s))
    return s.call(this, t, n);
  if (r && (t = n), !!l.isString(t)) {
    if (l.isString(s))
      return t.indexOf(s) !== -1;
    if (l.isRegExp(s))
      return s.test(t);
  }
}
function Rr(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, s) => n.toUpperCase() + s);
}
function vr(e, t) {
  const n = l.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(e, s + n, {
      value: function(r, i, o) {
        return this[s].call(this, t, r, i, o);
      },
      configurable: !0
    });
  });
}
let Z = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, s) {
    const r = this;
    function i(a, c, d) {
      const u = Ae(c);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const x = l.findKey(r, u);
      (!x || r[x] === void 0 || d === !0 || d === void 0 && r[x] !== !1) && (r[x || c] = Xe(a));
    }
    const o = (a, c) => l.forEach(a, (d, u) => i(d, u, c));
    if (l.isPlainObject(t) || t instanceof this.constructor)
      o(t, n);
    else if (l.isString(t) && (t = t.trim()) && !Cr(t))
      o(Sr(t), n);
    else if (l.isObject(t) && l.isIterable(t)) {
      let a = {}, c, d;
      for (const u of t) {
        if (!l.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        a[d = u[0]] = (c = a[d]) ? l.isArray(c) ? [...c, u[1]] : [c, u[1]] : u[1];
      }
      o(a, n);
    } else
      t != null && i(n, t, s);
    return this;
  }
  get(t, n) {
    if (t = Ae(t), t) {
      const s = l.findKey(this, t);
      if (s) {
        const r = this[s];
        if (!n)
          return r;
        if (n === !0)
          return kr(r);
        if (l.isFunction(n))
          return n.call(this, r, s);
        if (l.isRegExp(n))
          return n.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Ae(t), t) {
      const s = l.findKey(this, t);
      return !!(s && this[s] !== void 0 && (!n || ft(this, this[s], s, n)));
    }
    return !1;
  }
  delete(t, n) {
    const s = this;
    let r = !1;
    function i(o) {
      if (o = Ae(o), o) {
        const a = l.findKey(s, o);
        a && (!n || ft(s, s[a], a, n)) && (delete s[a], r = !0);
      }
    }
    return l.isArray(t) ? t.forEach(i) : i(t), r;
  }
  clear(t) {
    const n = Object.keys(this);
    let s = n.length, r = !1;
    for (; s--; ) {
      const i = n[s];
      (!t || ft(this, this[i], i, t, !0)) && (delete this[i], r = !0);
    }
    return r;
  }
  normalize(t) {
    const n = this, s = {};
    return l.forEach(this, (r, i) => {
      const o = l.findKey(s, i);
      if (o) {
        n[o] = Xe(r), delete n[i];
        return;
      }
      const a = t ? Rr(i) : String(i).trim();
      a !== i && delete n[i], n[a] = Xe(r), s[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return l.forEach(this, (s, r) => {
      s != null && s !== !1 && (n[r] = t && l.isArray(s) ? s.join(", ") : s);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const s = new this(t);
    return n.forEach((r) => s.set(r)), s;
  }
  static accessor(t) {
    const s = (this[qt] = this[qt] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function i(o) {
      const a = Ae(o);
      s[a] || (vr(r, o), s[a] = !0);
    }
    return l.isArray(t) ? t.forEach(i) : i(t), this;
  }
};
Z.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
l.reduceDescriptors(Z.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(s) {
      this[n] = s;
    }
  };
});
l.freezeMethods(Z);
function ht(e, t) {
  const n = this || Ue, s = t || n, r = Z.from(s.headers);
  let i = s.data;
  return l.forEach(e, function(a) {
    i = a.call(n, i, r.normalize(), t ? t.status : void 0);
  }), r.normalize(), i;
}
function Rn(e) {
  return !!(e && e.__CANCEL__);
}
function $e(e, t, n) {
  v.call(this, e == null ? "canceled" : e, v.ERR_CANCELED, t, n), this.name = "CanceledError";
}
l.inherits($e, v, {
  __CANCEL__: !0
});
function vn(e, t, n) {
  const s = n.config.validateStatus;
  !n.status || !s || s(n.status) ? e(n) : t(new v(
    "Request failed with status code " + n.status,
    [v.ERR_BAD_REQUEST, v.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Er(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function $r(e, t) {
  e = e || 10;
  const n = new Array(e), s = new Array(e);
  let r = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const d = Date.now(), u = s[i];
    o || (o = d), n[r] = c, s[r] = d;
    let x = i, S = 0;
    for (; x !== r; )
      S += n[x++], x = x % e;
    if (r = (r + 1) % e, r === i && (i = (i + 1) % e), d - o < t)
      return;
    const R = u && d - u;
    return R ? Math.round(S * 1e3 / R) : void 0;
  };
}
function Nr(e, t) {
  let n = 0, s = 1e3 / t, r, i;
  const o = (d, u = Date.now()) => {
    n = u, r = null, i && (clearTimeout(i), i = null), e(...d);
  };
  return [(...d) => {
    const u = Date.now(), x = u - n;
    x >= s ? o(d, u) : (r = d, i || (i = setTimeout(() => {
      i = null, o(r);
    }, s - x)));
  }, () => r && o(r)];
}
const Ze = (e, t, n = 3) => {
  let s = 0;
  const r = $r(50, 250);
  return Nr((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, c = o - s, d = r(c), u = o <= a;
    s = o;
    const x = {
      loaded: o,
      total: a,
      progress: a ? o / a : void 0,
      bytes: c,
      rate: d || void 0,
      estimated: d && a && u ? (a - o) / d : void 0,
      event: i,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(x);
  }, n);
}, Vt = (e, t) => {
  const n = e != null;
  return [(s) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: s
  }), t[1]];
}, Wt = (e) => (...t) => l.asap(() => e(...t)), Or = W.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, W.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(W.origin),
  W.navigator && /(msie|trident)/i.test(W.navigator.userAgent)
) : () => !0, Ar = W.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, s, r, i) {
      const o = [e + "=" + encodeURIComponent(t)];
      l.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), l.isString(s) && o.push("path=" + s), l.isString(r) && o.push("domain=" + r), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Tr(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Pr(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function En(e, t, n) {
  let s = !Tr(t);
  return e && (s || n == !1) ? Pr(e, t) : t;
}
const Jt = (e) => e instanceof Z ? T({}, e) : e;
function we(e, t) {
  t = t || {};
  const n = {};
  function s(d, u, x, S) {
    return l.isPlainObject(d) && l.isPlainObject(u) ? l.merge.call({ caseless: S }, d, u) : l.isPlainObject(u) ? l.merge({}, u) : l.isArray(u) ? u.slice() : u;
  }
  function r(d, u, x, S) {
    if (l.isUndefined(u)) {
      if (!l.isUndefined(d))
        return s(void 0, d, x, S);
    } else return s(d, u, x, S);
  }
  function i(d, u) {
    if (!l.isUndefined(u))
      return s(void 0, u);
  }
  function o(d, u) {
    if (l.isUndefined(u)) {
      if (!l.isUndefined(d))
        return s(void 0, d);
    } else return s(void 0, u);
  }
  function a(d, u, x) {
    if (x in t)
      return s(d, u);
    if (x in e)
      return s(void 0, d);
  }
  const c = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: a,
    headers: (d, u, x) => r(Jt(d), Jt(u), x, !0)
  };
  return l.forEach(Object.keys(T(T({}, e), t)), function(u) {
    const x = c[u] || r, S = x(e[u], t[u], u);
    l.isUndefined(S) && x !== a || (n[u] = S);
  }), n;
}
const $n = (e) => {
  const t = we({}, e);
  let { data: n, withXSRFToken: s, xsrfHeaderName: r, xsrfCookieName: i, headers: o, auth: a } = t;
  if (t.headers = o = Z.from(o), t.url = Sn(En(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && o.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  ), l.isFormData(n)) {
    if (W.hasStandardBrowserEnv || W.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if (l.isFunction(n.getHeaders)) {
      const c = n.getHeaders(), d = ["content-type", "content-length"];
      Object.entries(c).forEach(([u, x]) => {
        d.includes(u.toLowerCase()) && o.set(u, x);
      });
    }
  }
  if (W.hasStandardBrowserEnv && (s && l.isFunction(s) && (s = s(t)), s || s !== !1 && Or(t.url))) {
    const c = r && i && Ar.read(i);
    c && o.set(r, c);
  }
  return t;
}, Fr = typeof XMLHttpRequest != "undefined", Lr = Fr && function(e) {
  return new Promise(function(n, s) {
    const r = $n(e);
    let i = r.data;
    const o = Z.from(r.headers).normalize();
    let { responseType: a, onUploadProgress: c, onDownloadProgress: d } = r, u, x, S, R, h;
    function _() {
      R && R(), h && h(), r.cancelToken && r.cancelToken.unsubscribe(u), r.signal && r.signal.removeEventListener("abort", u);
    }
    let g = new XMLHttpRequest();
    g.open(r.method.toUpperCase(), r.url, !0), g.timeout = r.timeout;
    function O() {
      if (!g)
        return;
      const k = Z.from(
        "getAllResponseHeaders" in g && g.getAllResponseHeaders()
      ), I = {
        data: !a || a === "text" || a === "json" ? g.responseText : g.response,
        status: g.status,
        statusText: g.statusText,
        headers: k,
        config: e,
        request: g
      };
      vn(function(F) {
        n(F), _();
      }, function(F) {
        s(F), _();
      }, I), g = null;
    }
    "onloadend" in g ? g.onloadend = O : g.onreadystatechange = function() {
      !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(O);
    }, g.onabort = function() {
      g && (s(new v("Request aborted", v.ECONNABORTED, e, g)), g = null);
    }, g.onerror = function(A) {
      const I = A && A.message ? A.message : "Network Error", q = new v(I, v.ERR_NETWORK, e, g);
      q.event = A || null, s(q), g = null;
    }, g.ontimeout = function() {
      let A = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const I = r.transitional || kn;
      r.timeoutErrorMessage && (A = r.timeoutErrorMessage), s(new v(
        A,
        I.clarifyTimeoutError ? v.ETIMEDOUT : v.ECONNABORTED,
        e,
        g
      )), g = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in g && l.forEach(o.toJSON(), function(A, I) {
      g.setRequestHeader(I, A);
    }), l.isUndefined(r.withCredentials) || (g.withCredentials = !!r.withCredentials), a && a !== "json" && (g.responseType = r.responseType), d && ([S, h] = Ze(d, !0), g.addEventListener("progress", S)), c && g.upload && ([x, R] = Ze(c), g.upload.addEventListener("progress", x), g.upload.addEventListener("loadend", R)), (r.cancelToken || r.signal) && (u = (k) => {
      g && (s(!k || k.type ? new $e(null, e, g) : k), g.abort(), g = null);
    }, r.cancelToken && r.cancelToken.subscribe(u), r.signal && (r.signal.aborted ? u() : r.signal.addEventListener("abort", u)));
    const $ = Er(r.url);
    if ($ && W.protocols.indexOf($) === -1) {
      s(new v("Unsupported protocol " + $ + ":", v.ERR_BAD_REQUEST, e));
      return;
    }
    g.send(i || null);
  });
}, Ir = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let s = new AbortController(), r;
    const i = function(d) {
      if (!r) {
        r = !0, a();
        const u = d instanceof Error ? d : this.reason;
        s.abort(u instanceof v ? u : new $e(u instanceof Error ? u.message : u));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new v(`timeout ${t} of ms exceeded`, v.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((d) => {
        d.unsubscribe ? d.unsubscribe(i) : d.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((d) => d.addEventListener("abort", i));
    const { signal: c } = s;
    return c.unsubscribe = () => l.asap(a), c;
  }
}, Ur = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let s = 0, r;
  for (; s < n; )
    r = s + t, yield e.slice(s, r), s = r;
}, Mr = function(e, t) {
  return ot(this, null, function* () {
    try {
      for (var n = Nt(zr(e)), s, r, i; s = !(r = yield new pe(n.next())).done; s = !1) {
        const o = r.value;
        yield* at(Ur(o, t));
      }
    } catch (r) {
      i = [r];
    } finally {
      try {
        s && (r = n.return) && (yield new pe(r.call(n)));
      } finally {
        if (i)
          throw i[0];
      }
    }
  });
}, zr = function(e) {
  return ot(this, null, function* () {
    if (e[Symbol.asyncIterator]) {
      yield* at(e);
      return;
    }
    const t = e.getReader();
    try {
      for (; ; ) {
        const { done: n, value: s } = yield new pe(t.read());
        if (n)
          break;
        yield s;
      }
    } finally {
      yield new pe(t.cancel());
    }
  });
}, Xt = (e, t, n, s) => {
  const r = Mr(e, t);
  let i = 0, o, a = (d) => {
    o || (o = !0, s && s(d));
  };
  return new ReadableStream({
    pull(d) {
      return ie(this, null, function* () {
        try {
          const { done: u, value: x } = yield r.next();
          if (u) {
            a(), d.close();
            return;
          }
          let S = x.byteLength;
          if (n) {
            let R = i += S;
            n(R);
          }
          d.enqueue(new Uint8Array(x));
        } catch (u) {
          throw a(u), u;
        }
      });
    },
    cancel(d) {
      return a(d), r.return();
    }
  }, {
    highWaterMark: 2
  });
}, Gt = 64 * 1024, { isFunction: Be } = l, Br = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(l.global), {
  ReadableStream: Kt,
  TextEncoder: Zt
} = l.global, Qt = (e, ...t) => {
  try {
    return !!e(...t);
  } catch (n) {
    return !1;
  }
}, Dr = (e) => {
  e = l.merge.call({
    skipUndefined: !0
  }, Br, e);
  const { fetch: t, Request: n, Response: s } = e, r = t ? Be(t) : typeof fetch == "function", i = Be(n), o = Be(s);
  if (!r)
    return !1;
  const a = r && Be(Kt), c = r && (typeof Zt == "function" ? /* @__PURE__ */ ((h) => (_) => h.encode(_))(new Zt()) : (h) => ie(null, null, function* () {
    return new Uint8Array(yield new n(h).arrayBuffer());
  })), d = i && a && Qt(() => {
    let h = !1;
    const _ = new n(W.origin, {
      body: new Kt(),
      method: "POST",
      get duplex() {
        return h = !0, "half";
      }
    }).headers.has("Content-Type");
    return h && !_;
  }), u = o && a && Qt(() => l.isReadableStream(new s("").body)), x = {
    stream: u && ((h) => h.body)
  };
  r && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((h) => {
    !x[h] && (x[h] = (_, g) => {
      let O = _ && _[h];
      if (O)
        return O.call(_);
      throw new v(`Response type '${h}' is not supported`, v.ERR_NOT_SUPPORT, g);
    });
  });
  const S = (h) => ie(null, null, function* () {
    if (h == null)
      return 0;
    if (l.isBlob(h))
      return h.size;
    if (l.isSpecCompliantForm(h))
      return (yield new n(W.origin, {
        method: "POST",
        body: h
      }).arrayBuffer()).byteLength;
    if (l.isArrayBufferView(h) || l.isArrayBuffer(h))
      return h.byteLength;
    if (l.isURLSearchParams(h) && (h = h + ""), l.isString(h))
      return (yield c(h)).byteLength;
  }), R = (h, _) => ie(null, null, function* () {
    const g = l.toFiniteNumber(h.getContentLength());
    return g == null ? S(_) : g;
  });
  return (h) => ie(null, null, function* () {
    let {
      url: _,
      method: g,
      data: O,
      signal: $,
      cancelToken: k,
      timeout: A,
      onDownloadProgress: I,
      onUploadProgress: q,
      responseType: F,
      headers: L,
      withCredentials: w = "same-origin",
      fetchOptions: b
    } = $n(h), y = t || fetch;
    F = F ? (F + "").toLowerCase() : "text";
    let p = Ir([$, k && k.toAbortSignal()], A), m = null;
    const j = p && p.unsubscribe && (() => {
      p.unsubscribe();
    });
    let C;
    try {
      if (q && d && g !== "get" && g !== "head" && (C = yield R(L, O)) !== 0) {
        let ne = new n(_, {
          method: "POST",
          body: O,
          duplex: "half"
        }), ue;
        if (l.isFormData(O) && (ue = ne.headers.get("content-type")) && L.setContentType(ue), ne.body) {
          const [Ne, _e] = Vt(
            C,
            Ze(Wt(q))
          );
          O = Xt(ne.body, Gt, Ne, _e);
        }
      }
      l.isString(w) || (w = w ? "include" : "omit");
      const E = i && "credentials" in n.prototype, V = X(T({}, b), {
        signal: p,
        method: g.toUpperCase(),
        headers: L.normalize().toJSON(),
        body: O,
        duplex: "half",
        credentials: E ? w : void 0
      });
      m = i && new n(_, V);
      let D = yield i ? y(m, b) : y(_, V);
      const ye = u && (F === "stream" || F === "response");
      if (u && (I || ye && j)) {
        const ne = {};
        ["status", "statusText", "headers"].forEach((Me) => {
          ne[Me] = D[Me];
        });
        const ue = l.toFiniteNumber(D.headers.get("content-length")), [Ne, _e] = I && Vt(
          ue,
          Ze(Wt(I), !0)
        ) || [];
        D = new s(
          Xt(D.body, Gt, Ne, () => {
            _e && _e(), j && j();
          }),
          ne
        );
      }
      F = F || "text";
      let it = yield x[l.findKey(x, F) || "text"](D, h);
      return !ye && j && j(), yield new Promise((ne, ue) => {
        vn(ne, ue, {
          data: it,
          headers: Z.from(D.headers),
          status: D.status,
          statusText: D.statusText,
          config: h,
          request: m
        });
      });
    } catch (E) {
      throw j && j(), E && E.name === "TypeError" && /Load failed|fetch/i.test(E.message) ? Object.assign(
        new v("Network Error", v.ERR_NETWORK, h, m),
        {
          cause: E.cause || E
        }
      ) : v.from(E, E && E.code, h, m);
    }
  });
}, Hr = /* @__PURE__ */ new Map(), Nn = (e) => {
  let t = e ? e.env : {};
  const { fetch: n, Request: s, Response: r } = t, i = [
    s,
    r,
    n
  ];
  let o = i.length, a = o, c, d, u = Hr;
  for (; a--; )
    c = i[a], d = u.get(c), d === void 0 && u.set(c, d = a ? /* @__PURE__ */ new Map() : Dr(t)), u = d;
  return d;
};
Nn();
const yt = {
  http: or,
  xhr: Lr,
  fetch: {
    get: Nn
  }
};
l.forEach(yt, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch (n) {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Yt = (e) => `- ${e}`, qr = (e) => l.isFunction(e) || e === null || e === !1, On = {
  getAdapter: (e, t) => {
    e = l.isArray(e) ? e : [e];
    const { length: n } = e;
    let s, r;
    const i = {};
    for (let o = 0; o < n; o++) {
      s = e[o];
      let a;
      if (r = s, !qr(s) && (r = yt[(a = String(s)).toLowerCase()], r === void 0))
        throw new v(`Unknown adapter '${a}'`);
      if (r && (l.isFunction(r) || (r = r.get(t))))
        break;
      i[a || "#" + o] = r;
    }
    if (!r) {
      const o = Object.entries(i).map(
        ([c, d]) => `adapter ${c} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = n ? o.length > 1 ? `since :
` + o.map(Yt).join(`
`) : " " + Yt(o[0]) : "as no adapter specified";
      throw new v(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: yt
};
function pt(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new $e(null, e);
}
function en(e) {
  return pt(e), e.headers = Z.from(e.headers), e.data = ht.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), On.getAdapter(e.adapter || Ue.adapter, e)(e).then(function(s) {
    return pt(e), s.data = ht.call(
      e,
      e.transformResponse,
      s
    ), s.headers = Z.from(s.headers), s;
  }, function(s) {
    return Rn(s) || (pt(e), s && s.response && (s.response.data = ht.call(
      e,
      e.transformResponse,
      s.response
    ), s.response.headers = Z.from(s.response.headers))), Promise.reject(s);
  });
}
const An = "1.12.2", rt = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  rt[e] = function(s) {
    return typeof s === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const tn = {};
rt.transitional = function(t, n, s) {
  function r(i, o) {
    return "[Axios v" + An + "] Transitional option '" + i + "'" + o + (s ? ". " + s : "");
  }
  return (i, o, a) => {
    if (t === !1)
      throw new v(
        r(o, " has been removed" + (n ? " in " + n : "")),
        v.ERR_DEPRECATED
      );
    return n && !tn[o] && (tn[o] = !0, console.warn(
      r(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, o, a) : !0;
  };
};
rt.spelling = function(t) {
  return (n, s) => (console.warn(`${s} is likely a misspelling of ${t}`), !0);
};
function Vr(e, t, n) {
  if (typeof e != "object")
    throw new v("options must be an object", v.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(e);
  let r = s.length;
  for (; r-- > 0; ) {
    const i = s[r], o = t[i];
    if (o) {
      const a = e[i], c = a === void 0 || o(a, i, e);
      if (c !== !0)
        throw new v("option " + i + " must be " + c, v.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new v("Unknown option " + i, v.ERR_BAD_OPTION);
  }
}
const Ge = {
  assertOptions: Vr,
  validators: rt
}, oe = Ge.validators;
let ge = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Ht(),
      response: new Ht()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    return ie(this, null, function* () {
      try {
        return yield this._request(t, n);
      } catch (s) {
        if (s instanceof Error) {
          let r = {};
          Error.captureStackTrace ? Error.captureStackTrace(r) : r = new Error();
          const i = r.stack ? r.stack.replace(/^.+\n/, "") : "";
          try {
            s.stack ? i && !String(s.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + i) : s.stack = i;
          } catch (o) {
          }
        }
        throw s;
      }
    });
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = we(this.defaults, n);
    const { transitional: s, paramsSerializer: r, headers: i } = n;
    s !== void 0 && Ge.assertOptions(s, {
      silentJSONParsing: oe.transitional(oe.boolean),
      forcedJSONParsing: oe.transitional(oe.boolean),
      clarifyTimeoutError: oe.transitional(oe.boolean)
    }, !1), r != null && (l.isFunction(r) ? n.paramsSerializer = {
      serialize: r
    } : Ge.assertOptions(r, {
      encode: oe.function,
      serialize: oe.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Ge.assertOptions(n, {
      baseUrl: oe.spelling("baseURL"),
      withXsrfToken: oe.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && l.merge(
      i.common,
      i[n.method]
    );
    i && l.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete i[h];
      }
    ), n.headers = Z.concat(o, i);
    const a = [];
    let c = !0;
    this.interceptors.request.forEach(function(_) {
      typeof _.runWhen == "function" && _.runWhen(n) === !1 || (c = c && _.synchronous, a.unshift(_.fulfilled, _.rejected));
    });
    const d = [];
    this.interceptors.response.forEach(function(_) {
      d.push(_.fulfilled, _.rejected);
    });
    let u, x = 0, S;
    if (!c) {
      const h = [en.bind(this), void 0];
      for (h.unshift(...a), h.push(...d), S = h.length, u = Promise.resolve(n); x < S; )
        u = u.then(h[x++], h[x++]);
      return u;
    }
    S = a.length;
    let R = n;
    for (; x < S; ) {
      const h = a[x++], _ = a[x++];
      try {
        R = h(R);
      } catch (g) {
        _.call(this, g);
        break;
      }
    }
    try {
      u = en.call(this, R);
    } catch (h) {
      return Promise.reject(h);
    }
    for (x = 0, S = d.length; x < S; )
      u = u.then(d[x++], d[x++]);
    return u;
  }
  getUri(t) {
    t = we(this.defaults, t);
    const n = En(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Sn(n, t.params, t.paramsSerializer);
  }
};
l.forEach(["delete", "get", "head", "options"], function(t) {
  ge.prototype[t] = function(n, s) {
    return this.request(we(s || {}, {
      method: t,
      url: n,
      data: (s || {}).data
    }));
  };
});
l.forEach(["post", "put", "patch"], function(t) {
  function n(s) {
    return function(i, o, a) {
      return this.request(we(a || {}, {
        method: t,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  ge.prototype[t] = n(), ge.prototype[t + "Form"] = n(!0);
});
let Wr = class Tn {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const s = this;
    this.promise.then((r) => {
      if (!s._listeners) return;
      let i = s._listeners.length;
      for (; i-- > 0; )
        s._listeners[i](r);
      s._listeners = null;
    }), this.promise.then = (r) => {
      let i;
      const o = new Promise((a) => {
        s.subscribe(a), i = a;
      }).then(r);
      return o.cancel = function() {
        s.unsubscribe(i);
      }, o;
    }, t(function(i, o, a) {
      s.reason || (s.reason = new $e(i, o, a), n(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (s) => {
      t.abort(s);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Tn(function(r) {
        t = r;
      }),
      cancel: t
    };
  }
};
function Jr(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function Xr(e) {
  return l.isObject(e) && e.isAxiosError === !0;
}
const _t = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(_t).forEach(([e, t]) => {
  _t[t] = e;
});
function Pn(e) {
  const t = new ge(e), n = un(ge.prototype.request, t);
  return l.extend(n, ge.prototype, t, { allOwnKeys: !0 }), l.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(r) {
    return Pn(we(e, r));
  }, n;
}
const U = Pn(Ue);
U.Axios = ge;
U.CanceledError = $e;
U.CancelToken = Wr;
U.isCancel = Rn;
U.VERSION = An;
U.toFormData = st;
U.AxiosError = v;
U.Cancel = U.CanceledError;
U.all = function(t) {
  return Promise.all(t);
};
U.spread = Jr;
U.isAxiosError = Xr;
U.mergeConfig = we;
U.AxiosHeaders = Z;
U.formToJSON = (e) => Cn(l.isHTMLForm(e) ? new FormData(e) : e);
U.getAdapter = On.getAdapter;
U.HttpStatusCode = _t;
U.default = U;
const {
  Axios: ci,
  AxiosError: li,
  CanceledError: di,
  isCancel: ui,
  CancelToken: fi,
  VERSION: hi,
  all: pi,
  Cancel: mi,
  isAxiosError: xi,
  spread: bi,
  toFormData: gi,
  AxiosHeaders: wi,
  HttpStatusCode: yi,
  formToJSON: _i,
  getAdapter: ji,
  mergeConfig: Si
} = U, Gr = 1e3 * 5, Kr = (n, ...s) => ie(null, [n, ...s], function* (e, t = {}) {
  var a, c, d;
  let r, i, o;
  try {
    const u = yield U({
      url: e,
      method: t.method,
      timeout: Gr
    });
    i = u.data, o = u.status;
  } catch (u) {
    U.isAxiosError(u) ? (i = (a = u.response) == null ? void 0 : a.data, r = (c = u.response) == null ? void 0 : c.statusText, o = (d = u.response) == null ? void 0 : d.status) : r = u == null ? void 0 : u.message;
  }
  return {
    error: r,
    data: i,
    statusCode: o
  };
}), nn = () => ({
  get: (e, t = {}) => Kr(e, X(T({}, t), {
    method: "GET"
  }))
}), Zr = [xt.groupType.BRAND, xt.groupType.CATEGORY], Qr = "default";
function ki({
  params: e = {},
  isStandaloneSite: t = !0,
  shouldLoad: n = !0,
  minTabs: s = 2,
  maxTabs: r = 9
}) {
  var F;
  const [i, o] = G([]), [a, c] = G(!0), [d, u] = G(!0), [x, S] = G(""), [R, h] = G([]), [_, g] = G(""), O = ee({}), $ = ee(!1), k = R == null ? void 0 : R.find((L) => L.groupId === _), A = Zr.includes(`${(F = k == null ? void 0 : k.groupType) == null ? void 0 : F.toLowerCase()}`), I = (L, w) => {
    const b = X(T({}, L), {
      groupId: w
    });
    return t ? Mt.getRecoDataAndes(b) : Mt.getRecoDataNonAndes(b);
  };
  return ae(() => {
    ie(null, null, function* () {
      if ($ != null && $.current || !n)
        return;
      const w = yield nn().get(I(e, Qr));
      if (w != null && w.error) {
        h([]), S(""), c(!1), u(!1), $.current = !0;
        return;
      }
      const {
        carouselName: b,
        groups: y,
        products: p
      } = Ut({
        data: w == null ? void 0 : w.data,
        isStandaloneSite: t,
        minTabs: s,
        maxTabs: r
      });
      if (y.length && p.length) {
        const m = y == null ? void 0 : y.find((j) => j == null ? void 0 : j.isDefault);
        if (m) {
          const j = m == null ? void 0 : m.groupId;
          O.current[j] = p, o(p), g(j);
        }
        S(b), h(y);
      }
      c(!1), u(!1), $.current = !0;
    });
  }, [n]), ae(() => {
    ie(null, null, function* () {
      if (!n || !_)
        return;
      const w = O.current[_];
      if (w) {
        o(w), c(!1);
        return;
      }
      c(!0);
      const b = yield nn().get(I(e, _));
      if (b != null && b.error) {
        o([]), c(!1);
        return;
      }
      const {
        products: y
      } = Ut({
        data: b == null ? void 0 : b.data,
        isStandaloneSite: t,
        minTabs: s,
        maxTabs: r
      });
      O.current[_] = y, o(y), c(!1);
    });
  }, [_, n]), {
    selectedGroupId: _,
    selectedGroup: k,
    isLoading: a,
    isFirstLoad: d,
    showMore: A,
    onGroupSelect: (L) => {
      L !== _ && g(L);
    },
    carouselName: x,
    groups: R,
    products: i
  };
}
export {
  ri as PillsButton,
  si as RecommendedProducts,
  ii as RecommendedProductsEmpty,
  si as default,
  ki as useRecoProducts
};
